export const usStatesWithCodes = [
  ['US-AL', 'Alabama'],
  ['US-AK', 'Alaska'],
  ['US-AZ', 'Arizona'],
  ['US-AR', 'Arkansas'],
  ['US-CA', 'California'],
  ['US-CO', 'Colorado'],
  ['US-CT', 'Connecticut'],
  ['US-DE', 'Delaware'],
  ['US-DC', 'District of Columbia'],
  ['US-FL', 'Florida'],
  ['US-GA', 'Georgia'],
  ['US-HI', 'Hawaii'],
  ['US-ID', 'Idaho'],
  ['US-IL', 'Illinois'],
  ['US-IN', 'Indiana'],
  ['US-IA', 'Iowa'],
  ['US-KS', 'Kansas'],
  ['US-KY', 'Kentucky'],
  ['US-LA', 'Louisiana'],
  ['US-ME', 'Maine'],
  ['US-MD', 'Maryland'],
  ['US-MA', 'Massachusetts'],
  ['US-MI', 'Michigan'],
  ['US-MN', 'Minnesota'],
  ['US-MS', 'Mississippi'],
  ['US-MO', 'Missouri'],
  ['US-MT', 'Montana'],
  ['US-NE', 'Nebraska'],
  ['US-NV', 'Nevada'],
  ['US-NH', 'New Hampshire'],
  ['US-NJ', 'New Jersey'],
  ['US-NM', 'New Mexico'],
  ['US-NY', 'New York'],
  ['US-NC', 'North Carolina'],
  ['US-ND', 'North Dakota'],
  ['US-OH', 'Ohio'],
  ['US-OK', 'Oklahoma'],
  ['US-OR', 'Oregon'],
  ['US-PA', 'Pennsylvania'],
  ['US-PR', 'Puerto Rico'],
  ['US-RI', 'Rhode Island'],
  ['US-SC', 'South Carolina'],
  ['US-SD', 'South Dakota'],
  ['US-TN', 'Tennessee'],
  ['US-TX', 'Texas'],
  ['US-UT', 'Utah'],
  ['US-VT', 'Vermont'],
  ['US-VA', 'Virginia'],
  ['US-WA', 'Washington'],
  ['US-WV', 'West Virginia'],
  ['US-WI', 'Wisconsin'],
  ['US-WY', 'Wyoming'],
];

export const canadianProvinces = [
  ['AB', 'Alberta'],
  ['BC', 'British Columbia'],
  ['MB', 'Manitoba'],
  ['NB', 'New Brunswick'],
  ['NL', 'Newfoundland and Labrador'],
  ['NS', 'Nova Scotia'],
  ['NT', 'Northwest Territories'],
  ['NU', 'Nunavut'],
  ['ON', 'Ontario'],
  ['PE', 'Prince Edward Island'],
  ['QC', 'Quebec'],
  ['SK', 'Saskatchewan'],
  ['YT', 'Yukon'],
];

export const counties = [
  ['AL-01', 'Autauga, AL'],
  ['AL-02', 'Baldwin, AL'],
  ['AL-03', 'Barbour, AL'],
  ['AL-04', 'Bibb, AL'],
  ['AL-05', 'Blount, AL'],
  ['AL-06', 'Bullock, AL'],
  ['AL-07', 'Butler, AL'],
  ['AL-08', 'Calhoun, AL'],
  ['AL-09', 'Chambers, AL'],
  ['AL-0A', 'Cherokee, AL'],
  ['AL-0B', 'Chilton, AL'],
  ['AL-0C', 'Choctaw, AL'],
  ['AL-0D', 'Clarke, AL'],
  ['AL-0E', 'Clay, AL'],
  ['AL-0F', 'Cleburne, AL'],
  ['AL-10', 'Coffee, AL'],
  ['AL-11', 'Colbert, AL'],
  ['AL-12', 'Conecuh, AL'],
  ['AL-13', 'Coosa, AL'],
  ['AL-14', 'Covington, AL'],
  ['AL-15', 'Crenshaw, AL'],
  ['AL-16', 'Cullman, AL'],
  ['AL-17', 'Dale, AL'],
  ['AL-18', 'Dallas, AL'],
  ['AL-19', 'DeKalb, AL'],
  ['AL-1A', 'Elmore, AL'],
  ['AL-1B', 'Escambia, AL'],
  ['AL-1C', 'Etowah, AL'],
  ['AL-1D', 'Fayette, AL'],
  ['AL-1E', 'Franklin, AL'],
  ['AL-1F', 'Geneva, AL'],
  ['AL-20', 'Greene, AL'],
  ['AL-21', 'Hale, AL'],
  ['AL-22', 'Henry, AL'],
  ['AL-23', 'Houston, AL'],
  ['AL-24', 'Jackson, AL'],
  ['AL-25', 'Jefferson, AL'],
  ['AL-26', 'Lamar, AL'],
  ['AL-27', 'Lauderdale, AL'],
  ['AL-28', 'Lawrence, AL'],
  ['AL-29', 'Lee, AL'],
  ['AL-2A', 'Limestone, AL'],
  ['AL-2B', 'Lowndes, AL'],
  ['AL-2C', 'Macon, AL'],
  ['AL-2D', 'Madison, AL'],
  ['AL-2E', 'Marengo, AL'],
  ['AL-2F', 'Marion, AL'],
  ['AL-30', 'Marshall, AL'],
  ['AL-31', 'Mobile, AL'],
  ['AL-32', 'Monroe, AL'],
  ['AL-33', 'Montgomery, AL'],
  ['AL-34', 'Morgan, AL'],
  ['AL-35', 'Perry, AL'],
  ['AL-36', 'Pickens, AL'],
  ['AL-37', 'Pike, AL'],
  ['AL-38', 'Randolph, AL'],
  ['AL-39', 'Russell, AL'],
  ['AL-3A', 'St. Clair, AL'],
  ['AL-3B', 'Shelby, AL'],
  ['AL-3C', 'Sumter, AL'],
  ['AL-3D', 'Talladega, AL'],
  ['AL-3E', 'Tallapoosa, AL'],
  ['AL-3F', 'Tuscaloosa, AL'],
  ['AL-40', 'Walker, AL'],
  ['AL-41', 'Washington, AL'],
  ['AL-42', 'Wilcox, AL'],
  ['AL-43', 'Winston, AL'],
  ['AK-01', 'Aleutians East, AK'],
  ['AK-02', 'Aleutians West, AK'],
  ['AK-03', 'Anchorage, AK'],
  ['AK-04', 'Bethel, AK'],
  ['AK-05', 'Bristol Bay, AK'],
  ['AK-06', 'Denali, AK'],
  ['AK-07', 'Dillingham, AK'],
  ['AK-08', 'Fairbanks North Star, AK'],
  ['AK-09', 'Haines, AK'],
  ['AK-0A', 'Hoonah-Angoon, AK'],
  ['AK-0B', 'Juneau, AK'],
  ['AK-0C', 'Kenai Peninsula, AK'],
  ['AK-0D', 'Ketchikan Gateway, AK'],
  ['AK-0E', 'Kodiak Island, AK'],
  ['AK-0F', 'Kusilvak, AK'],
  ['AK-10', 'Lake and Peninsula, AK'],
  ['AK-11', 'Matanuska-Susitna, AK'],
  ['AK-12', 'Nome, AK'],
  ['AK-13', 'North Slope, AK'],
  ['AK-14', 'Northwest Arctic, AK'],
  ['AK-15', 'Petersburg, AK'],
  ['AK-16', 'Prince of Wales-Hyder, AK'],
  ['AK-17', 'Sitka, AK'],
  ['AK-18', 'Skagway, AK'],
  ['AK-19', 'Southeast Fairbanks, AK'],
  ['AK-1A', 'Valdez-Cordova, AK'],
  ['AK-1B', 'Wrangell, AK'],
  ['AK-1C', 'Yakutat, AK'],
  ['AK-1D', 'Yukon-Koyukuk, AK'],
  ['AZ-01', 'Apache, AZ'],
  ['AZ-02', 'Cochise, AZ'],
  ['AZ-03', 'Coconino, AZ'],
  ['AZ-04', 'Gila, AZ'],
  ['AZ-05', 'Graham, AZ'],
  ['AZ-06', 'Greenlee, AZ'],
  ['AZ-07', 'La Paz, AZ'],
  ['AZ-08', 'Maricopa, AZ'],
  ['AZ-09', 'Mohave, AZ'],
  ['AZ-0A', 'Navajo, AZ'],
  ['AZ-0B', 'Pima, AZ'],
  ['AZ-0C', 'Pinal, AZ'],
  ['AZ-0D', 'Santa Cruz, AZ'],
  ['AZ-0E', 'Yavapai, AZ'],
  ['AZ-0F', 'Yuma, AZ'],
  ['AR-01', 'Arkansas, AR'],
  ['AR-02', 'Ashley, AR'],
  ['AR-03', 'Baxter, AR'],
  ['AR-04', 'Benton, AR'],
  ['AR-05', 'Boone, AR'],
  ['AR-06', 'Bradley, AR'],
  ['AR-07', 'Calhoun, AR'],
  ['AR-08', 'Carroll, AR'],
  ['AR-09', 'Chicot, AR'],
  ['AR-0A', 'Clark, AR'],
  ['AR-0B', 'Clay, AR'],
  ['AR-0C', 'Cleburne, AR'],
  ['AR-0D', 'Cleveland, AR'],
  ['AR-0E', 'Columbia, AR'],
  ['AR-0F', 'Conway, AR'],
  ['AR-10', 'Craighead, AR'],
  ['AR-11', 'Crawford, AR'],
  ['AR-12', 'Crittenden, AR'],
  ['AR-13', 'Cross, AR'],
  ['AR-14', 'Dallas, AR'],
  ['AR-15', 'Desha, AR'],
  ['AR-16', 'Drew, AR'],
  ['AR-17', 'Faulkner, AR'],
  ['AR-18', 'Franklin, AR'],
  ['AR-19', 'Fulton, AR'],
  ['AR-1A', 'Garland, AR'],
  ['AR-1B', 'Grant, AR'],
  ['AR-1C', 'Greene, AR'],
  ['AR-1D', 'Hempstead, AR'],
  ['AR-1E', 'Hot Spring, AR'],
  ['AR-1F', 'Howard, AR'],
  ['AR-20', 'Independence, AR'],
  ['AR-21', 'Izard, AR'],
  ['AR-22', 'Jackson, AR'],
  ['AR-23', 'Jefferson, AR'],
  ['AR-24', 'Johnson, AR'],
  ['AR-25', 'Lafayette, AR'],
  ['AR-26', 'Lawrence, AR'],
  ['AR-27', 'Lee, AR'],
  ['AR-28', 'Lincoln, AR'],
  ['AR-29', 'Little River, AR'],
  ['AR-2A', 'Logan, AR'],
  ['AR-2B', 'Lonoke, AR'],
  ['AR-2C', 'Madison, AR'],
  ['AR-2D', 'Marion, AR'],
  ['AR-2E', 'Miller, AR'],
  ['AR-2F', 'Mississippi, AR'],
  ['AR-30', 'Monroe, AR'],
  ['AR-31', 'Montgomery, AR'],
  ['AR-32', 'Nevada, AR'],
  ['AR-33', 'Newton, AR'],
  ['AR-34', 'Ouachita, AR'],
  ['AR-35', 'Perry, AR'],
  ['AR-36', 'Phillips, AR'],
  ['AR-37', 'Pike, AR'],
  ['AR-38', 'Poinsett, AR'],
  ['AR-39', 'Polk, AR'],
  ['AR-3A', 'Pope, AR'],
  ['AR-3B', 'Prairie, AR'],
  ['AR-3C', 'Pulaski, AR'],
  ['AR-3D', 'Randolph, AR'],
  ['AR-3E', 'St. Francis, AR'],
  ['AR-3F', 'Saline, AR'],
  ['AR-40', 'Scott, AR'],
  ['AR-41', 'Searcy, AR'],
  ['AR-42', 'Sebastian, AR'],
  ['AR-43', 'Sevier, AR'],
  ['AR-44', 'Sharp, AR'],
  ['AR-45', 'Stone, AR'],
  ['AR-46', 'Union, AR'],
  ['AR-47', 'Van Buren, AR'],
  ['AR-48', 'Washington, AR'],
  ['AR-49', 'White, AR'],
  ['AR-4A', 'Woodruff, AR'],
  ['AR-4B', 'Yell, AR'],
  ['CA-01', 'Alameda, CA'],
  ['CA-02', 'Alpine, CA'],
  ['CA-03', 'Amador, CA'],
  ['CA-04', 'Butte, CA'],
  ['CA-05', 'Calaveras, CA'],
  ['CA-06', 'Colusa, CA'],
  ['CA-07', 'Contra Costa, CA'],
  ['CA-08', 'Del Norte, CA'],
  ['CA-09', 'El Dorado, CA'],
  ['CA-0A', 'Fresno, CA'],
  ['CA-0B', 'Glenn, CA'],
  ['CA-0C', 'Humboldt, CA'],
  ['CA-0D', 'Imperial, CA'],
  ['CA-0E', 'Inyo, CA'],
  ['CA-0F', 'Kern, CA'],
  ['CA-10', 'Kings, CA'],
  ['CA-11', 'Lake, CA'],
  ['CA-12', 'Lassen, CA'],
  ['CA-13', 'Los Angeles, CA'],
  ['CA-14', 'Madera, CA'],
  ['CA-15', 'Marin, CA'],
  ['CA-16', 'Mariposa, CA'],
  ['CA-17', 'Mendocino, CA'],
  ['CA-18', 'Merced, CA'],
  ['CA-19', 'Modoc, CA'],
  ['CA-1A', 'Mono, CA'],
  ['CA-1B', 'Monterey, CA'],
  ['CA-1C', 'Napa, CA'],
  ['CA-1D', 'Nevada, CA'],
  ['CA-1E', 'Orange, CA'],
  ['CA-1F', 'Placer, CA'],
  ['CA-20', 'Plumas, CA'],
  ['CA-21', 'Riverside, CA'],
  ['CA-22', 'Sacramento, CA'],
  ['CA-23', 'San Benito, CA'],
  ['CA-24', 'San Bernardino, CA'],
  ['CA-25', 'San Diego, CA'],
  ['CA-26', 'San Francisco, CA'],
  ['CA-27', 'San Joaquin, CA'],
  ['CA-28', 'San Luis Obispo, CA'],
  ['CA-29', 'San Mateo, CA'],
  ['CA-2A', 'Santa Barbara, CA'],
  ['CA-2B', 'Santa Clara, CA'],
  ['CA-2C', 'Santa Cruz, CA'],
  ['CA-2D', 'Shasta, CA'],
  ['CA-2E', 'Sierra, CA'],
  ['CA-2F', 'Siskiyou, CA'],
  ['CA-30', 'Solano, CA'],
  ['CA-31', 'Sonoma, CA'],
  ['CA-32', 'Stanislaus, CA'],
  ['CA-33', 'Sutter, CA'],
  ['CA-34', 'Tehama, CA'],
  ['CA-35', 'Trinity, CA'],
  ['CA-36', 'Tulare, CA'],
  ['CA-37', 'Tuolumne, CA'],
  ['CA-38', 'Ventura, CA'],
  ['CA-39', 'Yolo, CA'],
  ['CA-3A', 'Yuba, CA'],
  ['CO-01', 'Adams, CO'],
  ['CO-02', 'Alamosa, CO'],
  ['CO-03', 'Arapahoe, CO'],
  ['CO-04', 'Archuleta, CO'],
  ['CO-05', 'Baca, CO'],
  ['CO-06', 'Bent, CO'],
  ['CO-07', 'Boulder, CO'],
  ['CO-08', 'Broomfield, CO'],
  ['CO-09', 'Chaffee, CO'],
  ['CO-0A', 'Cheyenne, CO'],
  ['CO-0B', 'Clear Creek, CO'],
  ['CO-0C', 'Conejos, CO'],
  ['CO-0D', 'Costilla, CO'],
  ['CO-0E', 'Crowley, CO'],
  ['CO-0F', 'Custer, CO'],
  ['CO-10', 'Delta, CO'],
  ['CO-11', 'Denver, CO'],
  ['CO-12', 'Dolores, CO'],
  ['CO-13', 'Douglas, CO'],
  ['CO-14', 'Eagle, CO'],
  ['CO-15', 'Elbert, CO'],
  ['CO-16', 'El Paso, CO'],
  ['CO-17', 'Fremont, CO'],
  ['CO-18', 'Garfield, CO'],
  ['CO-19', 'Gilpin, CO'],
  ['CO-1A', 'Grand, CO'],
  ['CO-1B', 'Gunnison, CO'],
  ['CO-1C', 'Hinsdale, CO'],
  ['CO-1D', 'Huerfano, CO'],
  ['CO-1E', 'Jackson, CO'],
  ['CO-1F', 'Jefferson, CO'],
  ['CO-20', 'Kiowa, CO'],
  ['CO-21', 'Kit Carson, CO'],
  ['CO-22', 'Lake, CO'],
  ['CO-23', 'La Plata, CO'],
  ['CO-24', 'Larimer, CO'],
  ['CO-25', 'Las Animas, CO'],
  ['CO-26', 'Lincoln, CO'],
  ['CO-27', 'Logan, CO'],
  ['CO-28', 'Mesa, CO'],
  ['CO-29', 'Mineral, CO'],
  ['CO-2A', 'Moffat, CO'],
  ['CO-2B', 'Montezuma, CO'],
  ['CO-2C', 'Montrose, CO'],
  ['CO-2D', 'Morgan, CO'],
  ['CO-2E', 'Otero, CO'],
  ['CO-2F', 'Ouray, CO'],
  ['CO-30', 'Park, CO'],
  ['CO-31', 'Phillips, CO'],
  ['CO-32', 'Pitkin, CO'],
  ['CO-33', 'Prowers, CO'],
  ['CO-34', 'Pueblo, CO'],
  ['CO-35', 'Rio Blanco, CO'],
  ['CO-36', 'Rio Grande, CO'],
  ['CO-37', 'Routt, CO'],
  ['CO-38', 'Saguache, CO'],
  ['CO-39', 'San Juan, CO'],
  ['CO-3A', 'San Miguel, CO'],
  ['CO-3B', 'Sedgwick, CO'],
  ['CO-3C', 'Summit, CO'],
  ['CO-3D', 'Teller, CO'],
  ['CO-3E', 'Washington, CO'],
  ['CO-3F', 'Weld, CO'],
  ['CO-40', 'Yuma, CO'],
  ['CT-01', 'Fairfield, CT'],
  ['CT-02', 'Hartford, CT'],
  ['CT-03', 'Litchfield, CT'],
  ['CT-04', 'Middlesex, CT'],
  ['CT-05', 'New Haven, CT'],
  ['CT-06', 'New London, CT'],
  ['CT-07', 'Tolland, CT'],
  ['CT-08', 'Windham, CT'],
  ['DE-01', 'Kent, DE'],
  ['DE-02', 'New Castle, DE'],
  ['DE-03', 'Sussex, DE'],
  ['DC-01', 'District of Columbia, DC'],
  ['FL-01', 'Alachua, FL'],
  ['FL-02', 'Baker, FL'],
  ['FL-03', 'Bay, FL'],
  ['FL-04', 'Bradford, FL'],
  ['FL-05', 'Brevard, FL'],
  ['FL-06', 'Broward, FL'],
  ['FL-07', 'Calhoun, FL'],
  ['FL-08', 'Charlotte, FL'],
  ['FL-09', 'Citrus, FL'],
  ['FL-0A', 'Clay, FL'],
  ['FL-0B', 'Collier, FL'],
  ['FL-0C', 'Columbia, FL'],
  ['FL-0D', 'DeSoto, FL'],
  ['FL-0E', 'Dixie, FL'],
  ['FL-0F', 'Duval, FL'],
  ['FL-10', 'Escambia, FL'],
  ['FL-11', 'Flagler, FL'],
  ['FL-12', 'Franklin, FL'],
  ['FL-13', 'Gadsden, FL'],
  ['FL-14', 'Gilchrist, FL'],
  ['FL-15', 'Glades, FL'],
  ['FL-16', 'Gulf, FL'],
  ['FL-17', 'Hamilton, FL'],
  ['FL-18', 'Hardee, FL'],
  ['FL-19', 'Hendry, FL'],
  ['FL-1A', 'Hernando, FL'],
  ['FL-1B', 'Highlands, FL'],
  ['FL-1C', 'Hillsborough, FL'],
  ['FL-1D', 'Holmes, FL'],
  ['FL-1E', 'Indian River, FL'],
  ['FL-1F', 'Jackson, FL'],
  ['FL-20', 'Jefferson, FL'],
  ['FL-21', 'Lafayette, FL'],
  ['FL-22', 'Lake, FL'],
  ['FL-23', 'Lee, FL'],
  ['FL-24', 'Leon, FL'],
  ['FL-25', 'Levy, FL'],
  ['FL-26', 'Liberty, FL'],
  ['FL-27', 'Madison, FL'],
  ['FL-28', 'Manatee, FL'],
  ['FL-29', 'Marion, FL'],
  ['FL-2A', 'Martin, FL'],
  ['FL-2B', 'Miami-Dade, FL'],
  ['FL-2C', 'Monroe, FL'],
  ['FL-2D', 'Nassau, FL'],
  ['FL-2E', 'Okaloosa, FL'],
  ['FL-2F', 'Okeechobee, FL'],
  ['FL-30', 'Orange, FL'],
  ['FL-31', 'Osceola, FL'],
  ['FL-32', 'Palm Beach, FL'],
  ['FL-33', 'Pasco, FL'],
  ['FL-34', 'Pinellas, FL'],
  ['FL-35', 'Polk, FL'],
  ['FL-36', 'Putnam, FL'],
  ['FL-37', 'St. Johns, FL'],
  ['FL-38', 'St. Lucie, FL'],
  ['FL-39', 'Santa Rosa, FL'],
  ['FL-3A', 'Sarasota, FL'],
  ['FL-3B', 'Seminole, FL'],
  ['FL-3C', 'Sumter, FL'],
  ['FL-3D', 'Suwannee, FL'],
  ['FL-3E', 'Taylor, FL'],
  ['FL-3F', 'Union, FL'],
  ['FL-40', 'Volusia, FL'],
  ['FL-41', 'Wakulla, FL'],
  ['FL-42', 'Walton, FL'],
  ['FL-43', 'Washington, FL'],
  ['GA-01', 'Appling, GA'],
  ['GA-02', 'Atkinson, GA'],
  ['GA-03', 'Bacon, GA'],
  ['GA-04', 'Baker, GA'],
  ['GA-05', 'Baldwin, GA'],
  ['GA-06', 'Banks, GA'],
  ['GA-07', 'Barrow, GA'],
  ['GA-08', 'Bartow, GA'],
  ['GA-09', 'Ben Hill, GA'],
  ['GA-0A', 'Berrien, GA'],
  ['GA-0B', 'Bibb, GA'],
  ['GA-0C', 'Bleckley, GA'],
  ['GA-0D', 'Brantley, GA'],
  ['GA-0E', 'Brooks, GA'],
  ['GA-0F', 'Bryan, GA'],
  ['GA-10', 'Bulloch, GA'],
  ['GA-11', 'Burke, GA'],
  ['GA-12', 'Butts, GA'],
  ['GA-13', 'Calhoun, GA'],
  ['GA-14', 'Camden, GA'],
  ['GA-15', 'Candler, GA'],
  ['GA-16', 'Carroll, GA'],
  ['GA-17', 'Catoosa, GA'],
  ['GA-18', 'Charlton, GA'],
  ['GA-19', 'Chatham, GA'],
  ['GA-1A', 'Chattahoochee, GA'],
  ['GA-1B', 'Chattooga, GA'],
  ['GA-1C', 'Cherokee, GA'],
  ['GA-1D', 'Clarke, GA'],
  ['GA-1E', 'Clay, GA'],
  ['GA-1F', 'Clayton, GA'],
  ['GA-20', 'Clinch, GA'],
  ['GA-21', 'Cobb, GA'],
  ['GA-22', 'Coffee, GA'],
  ['GA-23', 'Colquitt, GA'],
  ['GA-24', 'Columbia, GA'],
  ['GA-25', 'Cook, GA'],
  ['GA-26', 'Coweta, GA'],
  ['GA-27', 'Crawford, GA'],
  ['GA-28', 'Crisp, GA'],
  ['GA-29', 'Dade, GA'],
  ['GA-2A', 'Dawson, GA'],
  ['GA-2B', 'Decatur, GA'],
  ['GA-2C', 'DeKalb, GA'],
  ['GA-2D', 'Dodge, GA'],
  ['GA-2E', 'Dooly, GA'],
  ['GA-2F', 'Dougherty, GA'],
  ['GA-30', 'Douglas, GA'],
  ['GA-31', 'Early, GA'],
  ['GA-32', 'Echols, GA'],
  ['GA-33', 'Effingham, GA'],
  ['GA-34', 'Elbert, GA'],
  ['GA-35', 'Emanuel, GA'],
  ['GA-36', 'Evans, GA'],
  ['GA-37', 'Fannin, GA'],
  ['GA-38', 'Fayette, GA'],
  ['GA-39', 'Floyd, GA'],
  ['GA-3A', 'Forsyth, GA'],
  ['GA-3B', 'Franklin, GA'],
  ['GA-3C', 'Fulton, GA'],
  ['GA-3D', 'Gilmer, GA'],
  ['GA-3E', 'Glascock, GA'],
  ['GA-3F', 'Glynn, GA'],
  ['GA-40', 'Gordon, GA'],
  ['GA-41', 'Grady, GA'],
  ['GA-42', 'Greene, GA'],
  ['GA-43', 'Gwinnett, GA'],
  ['GA-44', 'Habersham, GA'],
  ['GA-45', 'Hall, GA'],
  ['GA-46', 'Hancock, GA'],
  ['GA-47', 'Haralson, GA'],
  ['GA-48', 'Harris, GA'],
  ['GA-49', 'Hart, GA'],
  ['GA-4A', 'Heard, GA'],
  ['GA-4B', 'Henry, GA'],
  ['GA-4C', 'Houston, GA'],
  ['GA-4D', 'Irwin, GA'],
  ['GA-4E', 'Jackson, GA'],
  ['GA-4F', 'Jasper, GA'],
  ['GA-50', 'Jeff Davis, GA'],
  ['GA-51', 'Jefferson, GA'],
  ['GA-52', 'Jenkins, GA'],
  ['GA-53', 'Johnson, GA'],
  ['GA-54', 'Jones, GA'],
  ['GA-55', 'Lamar, GA'],
  ['GA-56', 'Lanier, GA'],
  ['GA-57', 'Laurens, GA'],
  ['GA-58', 'Lee, GA'],
  ['GA-59', 'Liberty, GA'],
  ['GA-5A', 'Lincoln, GA'],
  ['GA-5B', 'Long, GA'],
  ['GA-5C', 'Lowndes, GA'],
  ['GA-5D', 'Lumpkin, GA'],
  ['GA-5E', 'McDuffie, GA'],
  ['GA-5F', 'McIntosh, GA'],
  ['GA-60', 'Macon, GA'],
  ['GA-61', 'Madison, GA'],
  ['GA-62', 'Marion, GA'],
  ['GA-63', 'Meriwether, GA'],
  ['GA-64', 'Miller, GA'],
  ['GA-65', 'Mitchell, GA'],
  ['GA-66', 'Monroe, GA'],
  ['GA-67', 'Montgomery, GA'],
  ['GA-68', 'Morgan, GA'],
  ['GA-69', 'Murray, GA'],
  ['GA-6A', 'Muscogee, GA'],
  ['GA-6B', 'Newton, GA'],
  ['GA-6C', 'Oconee, GA'],
  ['GA-6D', 'Oglethorpe, GA'],
  ['GA-6E', 'Paulding, GA'],
  ['GA-6F', 'Peach, GA'],
  ['GA-70', 'Pickens, GA'],
  ['GA-71', 'Pierce, GA'],
  ['GA-72', 'Pike, GA'],
  ['GA-73', 'Polk, GA'],
  ['GA-74', 'Pulaski, GA'],
  ['GA-75', 'Putnam, GA'],
  ['GA-76', 'Quitman, GA'],
  ['GA-77', 'Rabun, GA'],
  ['GA-78', 'Randolph, GA'],
  ['GA-79', 'Richmond, GA'],
  ['GA-7A', 'Rockdale, GA'],
  ['GA-7B', 'Schley, GA'],
  ['GA-7C', 'Screven, GA'],
  ['GA-7D', 'Seminole, GA'],
  ['GA-7E', 'Spalding, GA'],
  ['GA-7F', 'Stephens, GA'],
  ['GA-80', 'Stewart, GA'],
  ['GA-81', 'Sumter, GA'],
  ['GA-82', 'Talbot, GA'],
  ['GA-83', 'Taliaferro, GA'],
  ['GA-84', 'Tattnall, GA'],
  ['GA-85', 'Taylor, GA'],
  ['GA-86', 'Telfair, GA'],
  ['GA-87', 'Terrell, GA'],
  ['GA-88', 'Thomas, GA'],
  ['GA-89', 'Tift, GA'],
  ['GA-8A', 'Toombs, GA'],
  ['GA-8B', 'Towns, GA'],
  ['GA-8C', 'Treutlen, GA'],
  ['GA-8D', 'Troup, GA'],
  ['GA-8E', 'Turner, GA'],
  ['GA-8F', 'Twiggs, GA'],
  ['GA-90', 'Union, GA'],
  ['GA-91', 'Upson, GA'],
  ['GA-92', 'Walker, GA'],
  ['GA-93', 'Walton, GA'],
  ['GA-94', 'Ware, GA'],
  ['GA-95', 'Warren, GA'],
  ['GA-96', 'Washington, GA'],
  ['GA-97', 'Wayne, GA'],
  ['GA-98', 'Webster, GA'],
  ['GA-99', 'Wheeler, GA'],
  ['GA-9A', 'White, GA'],
  ['GA-9B', 'Whitfield, GA'],
  ['GA-9C', 'Wilcox, GA'],
  ['GA-9D', 'Wilkes, GA'],
  ['GA-9E', 'Wilkinson, GA'],
  ['GA-9F', 'Worth, GA'],
  ['HI-01', 'Hawaii, HI'],
  ['HI-02', 'Honolulu, HI'],
  ['HI-03', 'Kalawao, HI'],
  ['HI-04', 'Kauai, HI'],
  ['HI-05', 'Maui, HI'],
  ['ID-01', 'Ada, ID'],
  ['ID-02', 'Adams, ID'],
  ['ID-03', 'Bannock, ID'],
  ['ID-04', 'Bear Lake, ID'],
  ['ID-05', 'Benewah, ID'],
  ['ID-06', 'Bingham, ID'],
  ['ID-07', 'Blaine, ID'],
  ['ID-08', 'Boise, ID'],
  ['ID-09', 'Bonner, ID'],
  ['ID-0A', 'Bonneville, ID'],
  ['ID-0B', 'Boundary, ID'],
  ['ID-0C', 'Butte, ID'],
  ['ID-0D', 'Camas, ID'],
  ['ID-0E', 'Canyon, ID'],
  ['ID-0F', 'Caribou, ID'],
  ['ID-10', 'Cassia, ID'],
  ['ID-11', 'Clark, ID'],
  ['ID-12', 'Clearwater, ID'],
  ['ID-13', 'Custer, ID'],
  ['ID-14', 'Elmore, ID'],
  ['ID-15', 'Franklin, ID'],
  ['ID-16', 'Fremont, ID'],
  ['ID-17', 'Gem, ID'],
  ['ID-18', 'Gooding, ID'],
  ['ID-19', 'Idaho, ID'],
  ['ID-1A', 'Jefferson, ID'],
  ['ID-1B', 'Jerome, ID'],
  ['ID-1C', 'Kootenai, ID'],
  ['ID-1D', 'Latah, ID'],
  ['ID-1E', 'Lemhi, ID'],
  ['ID-1F', 'Lewis, ID'],
  ['ID-20', 'Lincoln, ID'],
  ['ID-21', 'Madison, ID'],
  ['ID-22', 'Minidoka, ID'],
  ['ID-23', 'Nez Perce, ID'],
  ['ID-24', 'Oneida, ID'],
  ['ID-25', 'Owyhee, ID'],
  ['ID-26', 'Payette, ID'],
  ['ID-27', 'Power, ID'],
  ['ID-28', 'Shoshone, ID'],
  ['ID-29', 'Teton, ID'],
  ['ID-2A', 'Twin Falls, ID'],
  ['ID-2B', 'Valley, ID'],
  ['ID-2C', 'Washington, ID'],
  ['IL-01', 'Adams, IL'],
  ['IL-02', 'Alexander, IL'],
  ['IL-03', 'Bond, IL'],
  ['IL-04', 'Boone, IL'],
  ['IL-05', 'Brown, IL'],
  ['IL-06', 'Bureau, IL'],
  ['IL-07', 'Calhoun, IL'],
  ['IL-08', 'Carroll, IL'],
  ['IL-09', 'Cass, IL'],
  ['IL-0A', 'Champaign, IL'],
  ['IL-0B', 'Christian, IL'],
  ['IL-0C', 'Clark, IL'],
  ['IL-0D', 'Clay, IL'],
  ['IL-0E', 'Clinton, IL'],
  ['IL-0F', 'Coles, IL'],
  ['IL-10', 'Cook, IL'],
  ['IL-11', 'Crawford, IL'],
  ['IL-12', 'Cumberland, IL'],
  ['IL-13', 'DeKalb, IL'],
  ['IL-14', 'DeWitt, IL'],
  ['IL-15', 'Douglas, IL'],
  ['IL-16', 'DuPage, IL'],
  ['IL-17', 'Edgar, IL'],
  ['IL-18', 'Edwards, IL'],
  ['IL-19', 'Effingham, IL'],
  ['IL-1A', 'Fayette, IL'],
  ['IL-1B', 'Ford, IL'],
  ['IL-1C', 'Franklin, IL'],
  ['IL-1D', 'Fulton, IL'],
  ['IL-1E', 'Gallatin, IL'],
  ['IL-1F', 'Greene, IL'],
  ['IL-20', 'Grundy, IL'],
  ['IL-21', 'Hamilton, IL'],
  ['IL-22', 'Hancock, IL'],
  ['IL-23', 'Hardin, IL'],
  ['IL-24', 'Henderson, IL'],
  ['IL-25', 'Henry, IL'],
  ['IL-26', 'Iroquois, IL'],
  ['IL-27', 'Jackson, IL'],
  ['IL-28', 'Jasper, IL'],
  ['IL-29', 'Jefferson, IL'],
  ['IL-2A', 'Jersey, IL'],
  ['IL-2B', 'Jo Daviess, IL'],
  ['IL-2C', 'Johnson, IL'],
  ['IL-2D', 'Kane, IL'],
  ['IL-2E', 'Kankakee, IL'],
  ['IL-2F', 'Kendall, IL'],
  ['IL-30', 'Knox, IL'],
  ['IL-31', 'Lake, IL'],
  ['IL-32', 'LaSalle, IL'],
  ['IL-33', 'Lawrence, IL'],
  ['IL-34', 'Lee, IL'],
  ['IL-35', 'Livingston, IL'],
  ['IL-36', 'Logan, IL'],
  ['IL-37', 'McDonough, IL'],
  ['IL-38', 'McHenry, IL'],
  ['IL-39', 'McLean, IL'],
  ['IL-3A', 'Macon, IL'],
  ['IL-3B', 'Macoupin, IL'],
  ['IL-3C', 'Madison, IL'],
  ['IL-3D', 'Marion, IL'],
  ['IL-3E', 'Marshall, IL'],
  ['IL-3F', 'Mason, IL'],
  ['IL-40', 'Massac, IL'],
  ['IL-41', 'Menard, IL'],
  ['IL-42', 'Mercer, IL'],
  ['IL-43', 'Monroe, IL'],
  ['IL-44', 'Montgomery, IL'],
  ['IL-45', 'Morgan, IL'],
  ['IL-46', 'Moultrie, IL'],
  ['IL-47', 'Ogle, IL'],
  ['IL-48', 'Peoria, IL'],
  ['IL-49', 'Perry, IL'],
  ['IL-4A', 'Piatt, IL'],
  ['IL-4B', 'Pike, IL'],
  ['IL-4C', 'Pope, IL'],
  ['IL-4D', 'Pulaski, IL'],
  ['IL-4E', 'Putnam, IL'],
  ['IL-4F', 'Randolph, IL'],
  ['IL-50', 'Richland, IL'],
  ['IL-51', 'Rock Island, IL'],
  ['IL-52', 'St. Clair, IL'],
  ['IL-53', 'Saline, IL'],
  ['IL-54', 'Sangamon, IL'],
  ['IL-55', 'Schuyler, IL'],
  ['IL-56', 'Scott, IL'],
  ['IL-57', 'Shelby, IL'],
  ['IL-58', 'Stark, IL'],
  ['IL-59', 'Stephenson, IL'],
  ['IL-5A', 'Tazewell, IL'],
  ['IL-5B', 'Union, IL'],
  ['IL-5C', 'Vermilion, IL'],
  ['IL-5D', 'Wabash, IL'],
  ['IL-5E', 'Warren, IL'],
  ['IL-5F', 'Washington, IL'],
  ['IL-60', 'Wayne, IL'],
  ['IL-61', 'White, IL'],
  ['IL-62', 'Whiteside, IL'],
  ['IL-63', 'Will, IL'],
  ['IL-64', 'Williamson, IL'],
  ['IL-65', 'Winnebago, IL'],
  ['IL-66', 'Woodford, IL'],
  ['IN-01', 'Adams, IN'],
  ['IN-02', 'Allen, IN'],
  ['IN-03', 'Bartholomew, IN'],
  ['IN-04', 'Benton, IN'],
  ['IN-05', 'Blackford, IN'],
  ['IN-06', 'Boone, IN'],
  ['IN-07', 'Brown, IN'],
  ['IN-08', 'Carroll, IN'],
  ['IN-09', 'Cass, IN'],
  ['IN-0A', 'Clark, IN'],
  ['IN-0B', 'Clay, IN'],
  ['IN-0C', 'Clinton, IN'],
  ['IN-0D', 'Crawford, IN'],
  ['IN-0E', 'Daviess, IN'],
  ['IN-0F', 'Dearborn, IN'],
  ['IN-10', 'Decatur, IN'],
  ['IN-11', 'DeKalb, IN'],
  ['IN-12', 'Delaware, IN'],
  ['IN-13', 'Dubois, IN'],
  ['IN-14', 'Elkhart, IN'],
  ['IN-15', 'Fayette, IN'],
  ['IN-16', 'Floyd, IN'],
  ['IN-17', 'Fountain, IN'],
  ['IN-18', 'Franklin, IN'],
  ['IN-19', 'Fulton, IN'],
  ['IN-1A', 'Gibson, IN'],
  ['IN-1B', 'Grant, IN'],
  ['IN-1C', 'Greene, IN'],
  ['IN-1D', 'Hamilton, IN'],
  ['IN-1E', 'Hancock, IN'],
  ['IN-1F', 'Harrison, IN'],
  ['IN-20', 'Hendricks, IN'],
  ['IN-21', 'Henry, IN'],
  ['IN-22', 'Howard, IN'],
  ['IN-23', 'Huntington, IN'],
  ['IN-24', 'Jackson, IN'],
  ['IN-25', 'Jasper, IN'],
  ['IN-26', 'Jay, IN'],
  ['IN-27', 'Jefferson, IN'],
  ['IN-28', 'Jennings, IN'],
  ['IN-29', 'Johnson, IN'],
  ['IN-2A', 'Knox, IN'],
  ['IN-2B', 'Kosciusko, IN'],
  ['IN-2C', 'Lagrange, IN'],
  ['IN-2D', 'Lake, IN'],
  ['IN-2E', 'LaPorte, IN'],
  ['IN-2F', 'Lawrence, IN'],
  ['IN-30', 'Madison, IN'],
  ['IN-31', 'Marion, IN'],
  ['IN-32', 'Marshall, IN'],
  ['IN-33', 'Martin, IN'],
  ['IN-34', 'Miami, IN'],
  ['IN-35', 'Monroe, IN'],
  ['IN-36', 'Montgomery, IN'],
  ['IN-37', 'Morgan, IN'],
  ['IN-38', 'Newton, IN'],
  ['IN-39', 'Noble, IN'],
  ['IN-3A', 'Ohio, IN'],
  ['IN-3B', 'Orange, IN'],
  ['IN-3C', 'Owen, IN'],
  ['IN-3D', 'Parke, IN'],
  ['IN-3E', 'Perry, IN'],
  ['IN-3F', 'Pike, IN'],
  ['IN-40', 'Porter, IN'],
  ['IN-41', 'Posey, IN'],
  ['IN-42', 'Pulaski, IN'],
  ['IN-43', 'Putnam, IN'],
  ['IN-44', 'Randolph, IN'],
  ['IN-45', 'Ripley, IN'],
  ['IN-46', 'Rush, IN'],
  ['IN-47', 'St. Joseph, IN'],
  ['IN-48', 'Scott, IN'],
  ['IN-49', 'Shelby, IN'],
  ['IN-4A', 'Spencer, IN'],
  ['IN-4B', 'Starke, IN'],
  ['IN-4C', 'Steuben, IN'],
  ['IN-4D', 'Sullivan, IN'],
  ['IN-4E', 'Switzerland, IN'],
  ['IN-4F', 'Tippecanoe, IN'],
  ['IN-50', 'Tipton, IN'],
  ['IN-51', 'Union, IN'],
  ['IN-52', 'Vanderburgh, IN'],
  ['IN-53', 'Vermillion, IN'],
  ['IN-54', 'Vigo, IN'],
  ['IN-55', 'Wabash, IN'],
  ['IN-56', 'Warren, IN'],
  ['IN-57', 'Warrick, IN'],
  ['IN-58', 'Washington, IN'],
  ['IN-59', 'Wayne, IN'],
  ['IN-5A', 'Wells, IN'],
  ['IN-5B', 'White, IN'],
  ['IN-5C', 'Whitley, IN'],
  ['IA-01', 'Adair, IA'],
  ['IA-02', 'Adams, IA'],
  ['IA-03', 'Allamakee, IA'],
  ['IA-04', 'Appanoose, IA'],
  ['IA-05', 'Audubon, IA'],
  ['IA-06', 'Benton, IA'],
  ['IA-07', 'Black Hawk, IA'],
  ['IA-08', 'Boone, IA'],
  ['IA-09', 'Bremer, IA'],
  ['IA-0A', 'Buchanan, IA'],
  ['IA-0B', 'Buena Vista, IA'],
  ['IA-0C', 'Butler, IA'],
  ['IA-0D', 'Calhoun, IA'],
  ['IA-0E', 'Carroll, IA'],
  ['IA-0F', 'Cass, IA'],
  ['IA-10', 'Cedar, IA'],
  ['IA-11', 'Cerro Gordo, IA'],
  ['IA-12', 'Cherokee, IA'],
  ['IA-13', 'Chickasaw, IA'],
  ['IA-14', 'Clarke, IA'],
  ['IA-15', 'Clay, IA'],
  ['IA-16', 'Clayton, IA'],
  ['IA-17', 'Clinton, IA'],
  ['IA-18', 'Crawford, IA'],
  ['IA-19', 'Dallas, IA'],
  ['IA-1A', 'Davis, IA'],
  ['IA-1B', 'Decatur, IA'],
  ['IA-1C', 'Delaware, IA'],
  ['IA-1D', 'Des Moines, IA'],
  ['IA-1E', 'Dickinson, IA'],
  ['IA-1F', 'Dubuque, IA'],
  ['IA-20', 'Emmet, IA'],
  ['IA-21', 'Fayette, IA'],
  ['IA-22', 'Floyd, IA'],
  ['IA-23', 'Franklin, IA'],
  ['IA-24', 'Fremont, IA'],
  ['IA-25', 'Greene, IA'],
  ['IA-26', 'Grundy, IA'],
  ['IA-27', 'Guthrie, IA'],
  ['IA-28', 'Hamilton, IA'],
  ['IA-29', 'Hancock, IA'],
  ['IA-2A', 'Hardin, IA'],
  ['IA-2B', 'Harrison, IA'],
  ['IA-2C', 'Henry, IA'],
  ['IA-2D', 'Howard, IA'],
  ['IA-2E', 'Humboldt, IA'],
  ['IA-2F', 'Ida, IA'],
  ['IA-30', 'Iowa, IA'],
  ['IA-31', 'Jackson, IA'],
  ['IA-32', 'Jasper, IA'],
  ['IA-33', 'Jefferson, IA'],
  ['IA-34', 'Johnson, IA'],
  ['IA-35', 'Jones, IA'],
  ['IA-36', 'Keokuk, IA'],
  ['IA-37', 'Kossuth, IA'],
  ['IA-38', 'Lee, IA'],
  ['IA-39', 'Linn, IA'],
  ['IA-3A', 'Louisa, IA'],
  ['IA-3B', 'Lucas, IA'],
  ['IA-3C', 'Lyon, IA'],
  ['IA-3D', 'Madison, IA'],
  ['IA-3E', 'Mahaska, IA'],
  ['IA-3F', 'Marion, IA'],
  ['IA-40', 'Marshall, IA'],
  ['IA-41', 'Mills, IA'],
  ['IA-42', 'Mitchell, IA'],
  ['IA-43', 'Monona, IA'],
  ['IA-44', 'Monroe, IA'],
  ['IA-45', 'Montgomery, IA'],
  ['IA-46', 'Muscatine, IA'],
  ['IA-47', "O'Brien, IA"],
  ['IA-48', 'Osceola, IA'],
  ['IA-49', 'Page, IA'],
  ['IA-4A', 'Palo Alto, IA'],
  ['IA-4B', 'Plymouth, IA'],
  ['IA-4C', 'Pocahontas, IA'],
  ['IA-4D', 'Polk, IA'],
  ['IA-4E', 'Pottawattamie, IA'],
  ['IA-4F', 'Poweshiek, IA'],
  ['IA-50', 'Ringgold, IA'],
  ['IA-51', 'Sac, IA'],
  ['IA-52', 'Scott, IA'],
  ['IA-53', 'Shelby, IA'],
  ['IA-54', 'Sioux, IA'],
  ['IA-55', 'Story, IA'],
  ['IA-56', 'Tama, IA'],
  ['IA-57', 'Taylor, IA'],
  ['IA-58', 'Union, IA'],
  ['IA-59', 'Van Buren, IA'],
  ['IA-5A', 'Wapello, IA'],
  ['IA-5B', 'Warren, IA'],
  ['IA-5C', 'Washington, IA'],
  ['IA-5D', 'Wayne, IA'],
  ['IA-5E', 'Webster, IA'],
  ['IA-5F', 'Winnebago, IA'],
  ['IA-60', 'Winneshiek, IA'],
  ['IA-61', 'Woodbury, IA'],
  ['IA-62', 'Worth, IA'],
  ['IA-63', 'Wright, IA'],
  ['KS-01', 'Allen, KS'],
  ['KS-02', 'Anderson, KS'],
  ['KS-03', 'Atchison, KS'],
  ['KS-04', 'Barber, KS'],
  ['KS-05', 'Barton, KS'],
  ['KS-06', 'Bourbon, KS'],
  ['KS-07', 'Brown, KS'],
  ['KS-08', 'Butler, KS'],
  ['KS-09', 'Chase, KS'],
  ['KS-0A', 'Chautauqua, KS'],
  ['KS-0B', 'Cherokee, KS'],
  ['KS-0C', 'Cheyenne, KS'],
  ['KS-0D', 'Clark, KS'],
  ['KS-0E', 'Clay, KS'],
  ['KS-0F', 'Cloud, KS'],
  ['KS-10', 'Coffey, KS'],
  ['KS-11', 'Comanche, KS'],
  ['KS-12', 'Cowley, KS'],
  ['KS-13', 'Crawford, KS'],
  ['KS-14', 'Decatur, KS'],
  ['KS-15', 'Dickinson, KS'],
  ['KS-16', 'Doniphan, KS'],
  ['KS-17', 'Douglas, KS'],
  ['KS-18', 'Edwards, KS'],
  ['KS-19', 'Elk, KS'],
  ['KS-1A', 'Ellis, KS'],
  ['KS-1B', 'Ellsworth, KS'],
  ['KS-1C', 'Finney, KS'],
  ['KS-1D', 'Ford, KS'],
  ['KS-1E', 'Franklin, KS'],
  ['KS-1F', 'Geary, KS'],
  ['KS-20', 'Gove, KS'],
  ['KS-21', 'Graham, KS'],
  ['KS-22', 'Grant, KS'],
  ['KS-23', 'Gray, KS'],
  ['KS-24', 'Greeley, KS'],
  ['KS-25', 'Greenwood, KS'],
  ['KS-26', 'Hamilton, KS'],
  ['KS-27', 'Harper, KS'],
  ['KS-28', 'Harvey, KS'],
  ['KS-29', 'Haskell, KS'],
  ['KS-2A', 'Hodgeman, KS'],
  ['KS-2B', 'Jackson, KS'],
  ['KS-2C', 'Jefferson, KS'],
  ['KS-2D', 'Jewell, KS'],
  ['KS-2E', 'Johnson, KS'],
  ['KS-2F', 'Kearny, KS'],
  ['KS-30', 'Kingman, KS'],
  ['KS-31', 'Kiowa, KS'],
  ['KS-32', 'Labette, KS'],
  ['KS-33', 'Lane, KS'],
  ['KS-34', 'Leavenworth, KS'],
  ['KS-35', 'Lincoln, KS'],
  ['KS-36', 'Linn, KS'],
  ['KS-37', 'Logan, KS'],
  ['KS-38', 'Lyon, KS'],
  ['KS-39', 'McPherson, KS'],
  ['KS-3A', 'Marion, KS'],
  ['KS-3B', 'Marshall, KS'],
  ['KS-3C', 'Meade, KS'],
  ['KS-3D', 'Miami, KS'],
  ['KS-3E', 'Mitchell, KS'],
  ['KS-3F', 'Montgomery, KS'],
  ['KS-40', 'Morris, KS'],
  ['KS-41', 'Morton, KS'],
  ['KS-42', 'Nemaha, KS'],
  ['KS-43', 'Neosho, KS'],
  ['KS-44', 'Ness, KS'],
  ['KS-45', 'Norton, KS'],
  ['KS-46', 'Osage, KS'],
  ['KS-47', 'Osborne, KS'],
  ['KS-48', 'Ottawa, KS'],
  ['KS-49', 'Pawnee, KS'],
  ['KS-4A', 'Phillips, KS'],
  ['KS-4B', 'Pottawatomie, KS'],
  ['KS-4C', 'Pratt, KS'],
  ['KS-4D', 'Rawlins, KS'],
  ['KS-4E', 'Reno, KS'],
  ['KS-4F', 'Republic, KS'],
  ['KS-50', 'Rice, KS'],
  ['KS-51', 'Riley, KS'],
  ['KS-52', 'Rooks, KS'],
  ['KS-53', 'Rush, KS'],
  ['KS-54', 'Russell, KS'],
  ['KS-55', 'Saline, KS'],
  ['KS-56', 'Scott, KS'],
  ['KS-57', 'Sedgwick, KS'],
  ['KS-58', 'Seward, KS'],
  ['KS-59', 'Shawnee, KS'],
  ['KS-5A', 'Sheridan, KS'],
  ['KS-5B', 'Sherman, KS'],
  ['KS-5C', 'Smith, KS'],
  ['KS-5D', 'Stafford, KS'],
  ['KS-5E', 'Stanton, KS'],
  ['KS-5F', 'Stevens, KS'],
  ['KS-60', 'Sumner, KS'],
  ['KS-61', 'Thomas, KS'],
  ['KS-62', 'Trego, KS'],
  ['KS-63', 'Wabaunsee, KS'],
  ['KS-64', 'Wallace, KS'],
  ['KS-65', 'Washington, KS'],
  ['KS-66', 'Wichita, KS'],
  ['KS-67', 'Wilson, KS'],
  ['KS-68', 'Woodson, KS'],
  ['KS-69', 'Wyandotte, KS'],
  ['KY-01', 'Adair, KY'],
  ['KY-02', 'Allen, KY'],
  ['KY-03', 'Anderson, KY'],
  ['KY-04', 'Ballard, KY'],
  ['KY-05', 'Barren, KY'],
  ['KY-06', 'Bath, KY'],
  ['KY-07', 'Bell, KY'],
  ['KY-08', 'Boone, KY'],
  ['KY-09', 'Bourbon, KY'],
  ['KY-0A', 'Boyd, KY'],
  ['KY-0B', 'Boyle, KY'],
  ['KY-0C', 'Bracken, KY'],
  ['KY-0D', 'Breathitt, KY'],
  ['KY-0E', 'Breckinridge, KY'],
  ['KY-0F', 'Bullitt, KY'],
  ['KY-10', 'Butler, KY'],
  ['KY-11', 'Caldwell, KY'],
  ['KY-12', 'Calloway, KY'],
  ['KY-13', 'Campbell, KY'],
  ['KY-14', 'Carlisle, KY'],
  ['KY-15', 'Carroll, KY'],
  ['KY-16', 'Carter, KY'],
  ['KY-17', 'Casey, KY'],
  ['KY-18', 'Christian, KY'],
  ['KY-19', 'Clark, KY'],
  ['KY-1A', 'Clay, KY'],
  ['KY-1B', 'Clinton, KY'],
  ['KY-1C', 'Crittenden, KY'],
  ['KY-1D', 'Cumberland, KY'],
  ['KY-1E', 'Daviess, KY'],
  ['KY-1F', 'Edmonson, KY'],
  ['KY-20', 'Elliott, KY'],
  ['KY-21', 'Estill, KY'],
  ['KY-22', 'Fayette, KY'],
  ['KY-23', 'Fleming, KY'],
  ['KY-24', 'Floyd, KY'],
  ['KY-25', 'Franklin, KY'],
  ['KY-26', 'Fulton, KY'],
  ['KY-27', 'Gallatin, KY'],
  ['KY-28', 'Garrard, KY'],
  ['KY-29', 'Grant, KY'],
  ['KY-2A', 'Graves, KY'],
  ['KY-2B', 'Grayson, KY'],
  ['KY-2C', 'Green, KY'],
  ['KY-2D', 'Greenup, KY'],
  ['KY-2E', 'Hancock, KY'],
  ['KY-2F', 'Hardin, KY'],
  ['KY-30', 'Harlan, KY'],
  ['KY-31', 'Harrison, KY'],
  ['KY-32', 'Hart, KY'],
  ['KY-33', 'Henderson, KY'],
  ['KY-34', 'Henry, KY'],
  ['KY-35', 'Hickman, KY'],
  ['KY-36', 'Hopkins, KY'],
  ['KY-37', 'Jackson, KY'],
  ['KY-38', 'Jefferson, KY'],
  ['KY-39', 'Jessamine, KY'],
  ['KY-3A', 'Johnson, KY'],
  ['KY-3B', 'Kenton, KY'],
  ['KY-3C', 'Knott, KY'],
  ['KY-3D', 'Knox, KY'],
  ['KY-3E', 'Larue, KY'],
  ['KY-3F', 'Laurel, KY'],
  ['KY-40', 'Lawrence, KY'],
  ['KY-41', 'Lee, KY'],
  ['KY-42', 'Leslie, KY'],
  ['KY-43', 'Letcher, KY'],
  ['KY-44', 'Lewis, KY'],
  ['KY-45', 'Lincoln, KY'],
  ['KY-46', 'Livingston, KY'],
  ['KY-47', 'Logan, KY'],
  ['KY-48', 'Lyon, KY'],
  ['KY-49', 'McCracken, KY'],
  ['KY-4A', 'McCreary, KY'],
  ['KY-4B', 'McLean, KY'],
  ['KY-4C', 'Madison, KY'],
  ['KY-4D', 'Magoffin, KY'],
  ['KY-4E', 'Marion, KY'],
  ['KY-4F', 'Marshall, KY'],
  ['KY-50', 'Martin, KY'],
  ['KY-51', 'Mason, KY'],
  ['KY-52', 'Meade, KY'],
  ['KY-53', 'Menifee, KY'],
  ['KY-54', 'Mercer, KY'],
  ['KY-55', 'Metcalfe, KY'],
  ['KY-56', 'Monroe, KY'],
  ['KY-57', 'Montgomery, KY'],
  ['KY-58', 'Morgan, KY'],
  ['KY-59', 'Muhlenberg, KY'],
  ['KY-5A', 'Nelson, KY'],
  ['KY-5B', 'Nicholas, KY'],
  ['KY-5C', 'Ohio, KY'],
  ['KY-5D', 'Oldham, KY'],
  ['KY-5E', 'Owen, KY'],
  ['KY-5F', 'Owsley, KY'],
  ['KY-60', 'Pendleton, KY'],
  ['KY-61', 'Perry, KY'],
  ['KY-62', 'Pike, KY'],
  ['KY-63', 'Powell, KY'],
  ['KY-64', 'Pulaski, KY'],
  ['KY-65', 'Robertson, KY'],
  ['KY-66', 'Rockcastle, KY'],
  ['KY-67', 'Rowan, KY'],
  ['KY-68', 'Russell, KY'],
  ['KY-69', 'Scott, KY'],
  ['KY-6A', 'Shelby, KY'],
  ['KY-6B', 'Simpson, KY'],
  ['KY-6C', 'Spencer, KY'],
  ['KY-6D', 'Taylor, KY'],
  ['KY-6E', 'Todd, KY'],
  ['KY-6F', 'Trigg, KY'],
  ['KY-70', 'Trimble, KY'],
  ['KY-71', 'Union, KY'],
  ['KY-72', 'Warren, KY'],
  ['KY-73', 'Washington, KY'],
  ['KY-74', 'Wayne, KY'],
  ['KY-75', 'Webster, KY'],
  ['KY-76', 'Whitley, KY'],
  ['KY-77', 'Wolfe, KY'],
  ['KY-78', 'Woodford, KY'],
  ['LA-01', 'Acadia, LA'],
  ['LA-02', 'Allen, LA'],
  ['LA-03', 'Ascension, LA'],
  ['LA-04', 'Assumption, LA'],
  ['LA-05', 'Avoyelles, LA'],
  ['LA-06', 'Beauregard, LA'],
  ['LA-07', 'Bienville, LA'],
  ['LA-08', 'Bossier, LA'],
  ['LA-09', 'Caddo, LA'],
  ['LA-0A', 'Calcasieu, LA'],
  ['LA-0B', 'Caldwell, LA'],
  ['LA-0C', 'Cameron, LA'],
  ['LA-0D', 'Catahoula, LA'],
  ['LA-0E', 'Claiborne, LA'],
  ['LA-0F', 'Concordia, LA'],
  ['LA-10', 'De Soto, LA'],
  ['LA-11', 'East Baton Rouge, LA'],
  ['LA-12', 'East Carroll, LA'],
  ['LA-13', 'East Feliciana, LA'],
  ['LA-14', 'Evangeline, LA'],
  ['LA-15', 'Franklin, LA'],
  ['LA-16', 'Grant, LA'],
  ['LA-17', 'Iberia, LA'],
  ['LA-18', 'Iberville, LA'],
  ['LA-19', 'Jackson, LA'],
  ['LA-1A', 'Jefferson, LA'],
  ['LA-1B', 'Jefferson Davis, LA'],
  ['LA-1C', 'Lafayette, LA'],
  ['LA-1D', 'Lafourche, LA'],
  ['LA-1E', 'LaSalle, LA'],
  ['LA-1F', 'Lincoln, LA'],
  ['LA-20', 'Livingston, LA'],
  ['LA-21', 'Madison, LA'],
  ['LA-22', 'Morehouse, LA'],
  ['LA-23', 'Natchitoches, LA'],
  ['LA-24', 'Orleans, LA'],
  ['LA-25', 'Ouachita, LA'],
  ['LA-26', 'Plaquemines, LA'],
  ['LA-27', 'Pointe Coupee, LA'],
  ['LA-28', 'Rapides, LA'],
  ['LA-29', 'Red River, LA'],
  ['LA-2A', 'Richland, LA'],
  ['LA-2B', 'Sabine, LA'],
  ['LA-2C', 'St. Bernard, LA'],
  ['LA-2D', 'St. Charles, LA'],
  ['LA-2E', 'St. Helena, LA'],
  ['LA-2F', 'St. James, LA'],
  ['LA-30', 'St. John the Baptist, LA'],
  ['LA-31', 'St. Landry, LA'],
  ['LA-32', 'St. Martin, LA'],
  ['LA-33', 'St. Mary, LA'],
  ['LA-34', 'St. Tammany, LA'],
  ['LA-35', 'Tangipahoa, LA'],
  ['LA-36', 'Tensas, LA'],
  ['LA-37', 'Terrebonne, LA'],
  ['LA-38', 'Union, LA'],
  ['LA-39', 'Vermilion, LA'],
  ['LA-3A', 'Vernon, LA'],
  ['LA-3B', 'Washington, LA'],
  ['LA-3C', 'Webster, LA'],
  ['LA-3D', 'West Baton Rouge, LA'],
  ['LA-3E', 'West Carroll, LA'],
  ['LA-3F', 'West Feliciana, LA'],
  ['LA-40', 'Winn, LA'],
  ['ME-01', 'Androscoggin, ME'],
  ['ME-02', 'Aroostook, ME'],
  ['ME-03', 'Cumberland, ME'],
  ['ME-04', 'Franklin, ME'],
  ['ME-05', 'Hancock, ME'],
  ['ME-06', 'Kennebec, ME'],
  ['ME-07', 'Knox, ME'],
  ['ME-08', 'Lincoln, ME'],
  ['ME-09', 'Oxford, ME'],
  ['ME-0A', 'Penobscot, ME'],
  ['ME-0B', 'Piscataquis, ME'],
  ['ME-0C', 'Sagadahoc, ME'],
  ['ME-0D', 'Somerset, ME'],
  ['ME-0E', 'Waldo, ME'],
  ['ME-0F', 'Washington, ME'],
  ['ME-10', 'York, ME'],
  ['MD-01', 'Allegany, MD'],
  ['MD-02', 'Anne Arundel, MD'],
  ['MD-03', 'Baltimore, MD'],
  ['MD-04', 'Calvert, MD'],
  ['MD-05', 'Caroline, MD'],
  ['MD-06', 'Carroll, MD'],
  ['MD-07', 'Cecil, MD'],
  ['MD-08', 'Charles, MD'],
  ['MD-09', 'Dorchester, MD'],
  ['MD-0A', 'Frederick, MD'],
  ['MD-0B', 'Garrett, MD'],
  ['MD-0C', 'Harford, MD'],
  ['MD-0D', 'Howard, MD'],
  ['MD-0E', 'Kent, MD'],
  ['MD-0F', 'Montgomery, MD'],
  ['MD-10', "Prince George's, MD"],
  ['MD-11', "Queen Anne's, MD"],
  ['MD-12', "St. Mary's, MD"],
  ['MD-13', 'Somerset, MD'],
  ['MD-14', 'Talbot, MD'],
  ['MD-15', 'Washington, MD'],
  ['MD-16', 'Wicomico, MD'],
  ['MD-17', 'Worcester, MD'],
  ['MD-18', 'Baltimore City, MD'],
  ['MA-01', 'Barnstable, MA'],
  ['MA-02', 'Berkshire, MA'],
  ['MA-03', 'Bristol, MA'],
  ['MA-04', 'Dukes, MA'],
  ['MA-05', 'Essex, MA'],
  ['MA-06', 'Franklin, MA'],
  ['MA-07', 'Hampden, MA'],
  ['MA-08', 'Hampshire, MA'],
  ['MA-09', 'Middlesex, MA'],
  ['MA-0A', 'Nantucket, MA'],
  ['MA-0B', 'Norfolk, MA'],
  ['MA-0C', 'Plymouth, MA'],
  ['MA-0D', 'Suffolk, MA'],
  ['MA-0E', 'Worcester, MA'],
  ['MI-01', 'Alcona, MI'],
  ['MI-02', 'Alger, MI'],
  ['MI-03', 'Allegan, MI'],
  ['MI-04', 'Alpena, MI'],
  ['MI-05', 'Antrim, MI'],
  ['MI-06', 'Arenac, MI'],
  ['MI-07', 'Baraga, MI'],
  ['MI-08', 'Barry, MI'],
  ['MI-09', 'Bay, MI'],
  ['MI-0A', 'Benzie, MI'],
  ['MI-0B', 'Berrien, MI'],
  ['MI-0C', 'Branch, MI'],
  ['MI-0D', 'Calhoun, MI'],
  ['MI-0E', 'Cass, MI'],
  ['MI-0F', 'Charlevoix, MI'],
  ['MI-10', 'Cheboygan, MI'],
  ['MI-11', 'Chippewa, MI'],
  ['MI-12', 'Clare, MI'],
  ['MI-13', 'Clinton, MI'],
  ['MI-14', 'Crawford, MI'],
  ['MI-15', 'Delta, MI'],
  ['MI-16', 'Dickinson, MI'],
  ['MI-17', 'Eaton, MI'],
  ['MI-18', 'Emmet, MI'],
  ['MI-19', 'Genesee, MI'],
  ['MI-1A', 'Gladwin, MI'],
  ['MI-1B', 'Gogebic, MI'],
  ['MI-1C', 'Grand Traverse, MI'],
  ['MI-1D', 'Gratiot, MI'],
  ['MI-1E', 'Hillsdale, MI'],
  ['MI-1F', 'Houghton, MI'],
  ['MI-20', 'Huron, MI'],
  ['MI-21', 'Ingham, MI'],
  ['MI-22', 'Ionia, MI'],
  ['MI-23', 'Iosco, MI'],
  ['MI-24', 'Iron, MI'],
  ['MI-25', 'Isabella, MI'],
  ['MI-26', 'Jackson, MI'],
  ['MI-27', 'Kalamazoo, MI'],
  ['MI-28', 'Kalkaska, MI'],
  ['MI-29', 'Kent, MI'],
  ['MI-2A', 'Keweenaw, MI'],
  ['MI-2B', 'Lake, MI'],
  ['MI-2C', 'Lapeer, MI'],
  ['MI-2D', 'Leelanau, MI'],
  ['MI-2E', 'Lenawee, MI'],
  ['MI-2F', 'Livingston, MI'],
  ['MI-30', 'Luce, MI'],
  ['MI-31', 'Mackinac, MI'],
  ['MI-32', 'Macomb, MI'],
  ['MI-33', 'Manistee, MI'],
  ['MI-34', 'Marquette, MI'],
  ['MI-35', 'Mason, MI'],
  ['MI-36', 'Mecosta, MI'],
  ['MI-37', 'Menominee, MI'],
  ['MI-38', 'Midland, MI'],
  ['MI-39', 'Missaukee, MI'],
  ['MI-3A', 'Monroe, MI'],
  ['MI-3B', 'Montcalm, MI'],
  ['MI-3C', 'Montmorency, MI'],
  ['MI-3D', 'Muskegon, MI'],
  ['MI-3E', 'Newaygo, MI'],
  ['MI-3F', 'Oakland, MI'],
  ['MI-40', 'Oceana, MI'],
  ['MI-41', 'Ogemaw, MI'],
  ['MI-42', 'Ontonagon, MI'],
  ['MI-43', 'Osceola, MI'],
  ['MI-44', 'Oscoda, MI'],
  ['MI-45', 'Otsego, MI'],
  ['MI-46', 'Ottawa, MI'],
  ['MI-47', 'Presque Isle, MI'],
  ['MI-48', 'Roscommon, MI'],
  ['MI-49', 'Saginaw, MI'],
  ['MI-4A', 'St. Clair, MI'],
  ['MI-4B', 'St. Joseph, MI'],
  ['MI-4C', 'Sanilac, MI'],
  ['MI-4D', 'Schoolcraft, MI'],
  ['MI-4E', 'Shiawassee, MI'],
  ['MI-4F', 'Tuscola, MI'],
  ['MI-50', 'Van Buren, MI'],
  ['MI-51', 'Washtenaw, MI'],
  ['MI-52', 'Wayne, MI'],
  ['MI-53', 'Wexford, MI'],
  ['MN-01', 'Aitkin, MN'],
  ['MN-02', 'Anoka, MN'],
  ['MN-03', 'Becker, MN'],
  ['MN-04', 'Beltrami, MN'],
  ['MN-05', 'Benton, MN'],
  ['MN-06', 'Big Stone, MN'],
  ['MN-07', 'Blue Earth, MN'],
  ['MN-08', 'Brown, MN'],
  ['MN-09', 'Carlton, MN'],
  ['MN-0A', 'Carver, MN'],
  ['MN-0B', 'Cass, MN'],
  ['MN-0C', 'Chippewa, MN'],
  ['MN-0D', 'Chisago, MN'],
  ['MN-0E', 'Clay, MN'],
  ['MN-0F', 'Clearwater, MN'],
  ['MN-10', 'Cook, MN'],
  ['MN-11', 'Cottonwood, MN'],
  ['MN-12', 'Crow Wing, MN'],
  ['MN-13', 'Dakota, MN'],
  ['MN-14', 'Dodge, MN'],
  ['MN-15', 'Douglas, MN'],
  ['MN-16', 'Faribault, MN'],
  ['MN-17', 'Fillmore, MN'],
  ['MN-18', 'Freeborn, MN'],
  ['MN-19', 'Goodhue, MN'],
  ['MN-1A', 'Grant, MN'],
  ['MN-1B', 'Hennepin, MN'],
  ['MN-1C', 'Houston, MN'],
  ['MN-1D', 'Hubbard, MN'],
  ['MN-1E', 'Isanti, MN'],
  ['MN-1F', 'Itasca, MN'],
  ['MN-20', 'Jackson, MN'],
  ['MN-21', 'Kanabec, MN'],
  ['MN-22', 'Kandiyohi, MN'],
  ['MN-23', 'Kittson, MN'],
  ['MN-24', 'Koochiching, MN'],
  ['MN-25', 'Lac qui Parle, MN'],
  ['MN-26', 'Lake, MN'],
  ['MN-27', 'Lake of the Woods, MN'],
  ['MN-28', 'Le Sueur, MN'],
  ['MN-29', 'Lincoln, MN'],
  ['MN-2A', 'Lyon, MN'],
  ['MN-2B', 'McLeod, MN'],
  ['MN-2C', 'Mahnomen, MN'],
  ['MN-2D', 'Marshall, MN'],
  ['MN-2E', 'Martin, MN'],
  ['MN-2F', 'Meeker, MN'],
  ['MN-30', 'Mille Lacs, MN'],
  ['MN-31', 'Morrison, MN'],
  ['MN-32', 'Mower, MN'],
  ['MN-33', 'Murray, MN'],
  ['MN-34', 'Nicollet, MN'],
  ['MN-35', 'Nobles, MN'],
  ['MN-36', 'Norman, MN'],
  ['MN-37', 'Olmsted, MN'],
  ['MN-38', 'Otter Tail, MN'],
  ['MN-39', 'Pennington, MN'],
  ['MN-3A', 'Pine, MN'],
  ['MN-3B', 'Pipestone, MN'],
  ['MN-3C', 'Polk, MN'],
  ['MN-3D', 'Pope, MN'],
  ['MN-3E', 'Ramsey, MN'],
  ['MN-3F', 'Red Lake, MN'],
  ['MN-40', 'Redwood, MN'],
  ['MN-41', 'Renville, MN'],
  ['MN-42', 'Rice, MN'],
  ['MN-43', 'Rock, MN'],
  ['MN-44', 'Roseau, MN'],
  ['MN-45', 'St. Louis, MN'],
  ['MN-46', 'Scott, MN'],
  ['MN-47', 'Sherburne, MN'],
  ['MN-48', 'Sibley, MN'],
  ['MN-49', 'Stearns, MN'],
  ['MN-4A', 'Steele, MN'],
  ['MN-4B', 'Stevens, MN'],
  ['MN-4C', 'Swift, MN'],
  ['MN-4D', 'Todd, MN'],
  ['MN-4E', 'Traverse, MN'],
  ['MN-4F', 'Wabasha, MN'],
  ['MN-50', 'Wadena, MN'],
  ['MN-51', 'Waseca, MN'],
  ['MN-52', 'Washington, MN'],
  ['MN-53', 'Watonwan, MN'],
  ['MN-54', 'Wilkin, MN'],
  ['MN-55', 'Winona, MN'],
  ['MN-56', 'Wright, MN'],
  ['MN-57', 'Yellow Medicine, MN'],
  ['MS-01', 'Adams, MS'],
  ['MS-02', 'Alcorn, MS'],
  ['MS-03', 'Amite, MS'],
  ['MS-04', 'Attala, MS'],
  ['MS-05', 'Benton, MS'],
  ['MS-06', 'Bolivar, MS'],
  ['MS-07', 'Calhoun, MS'],
  ['MS-08', 'Carroll, MS'],
  ['MS-09', 'Chickasaw, MS'],
  ['MS-0A', 'Choctaw, MS'],
  ['MS-0B', 'Claiborne, MS'],
  ['MS-0C', 'Clarke, MS'],
  ['MS-0D', 'Clay, MS'],
  ['MS-0E', 'Coahoma, MS'],
  ['MS-0F', 'Copiah, MS'],
  ['MS-10', 'Covington, MS'],
  ['MS-11', 'DeSoto, MS'],
  ['MS-12', 'Forrest, MS'],
  ['MS-13', 'Franklin, MS'],
  ['MS-14', 'George, MS'],
  ['MS-15', 'Greene, MS'],
  ['MS-16', 'Grenada, MS'],
  ['MS-17', 'Hancock, MS'],
  ['MS-18', 'Harrison, MS'],
  ['MS-19', 'Hinds, MS'],
  ['MS-1A', 'Holmes, MS'],
  ['MS-1B', 'Humphreys, MS'],
  ['MS-1C', 'Issaquena, MS'],
  ['MS-1D', 'Itawamba, MS'],
  ['MS-1E', 'Jackson, MS'],
  ['MS-1F', 'Jasper, MS'],
  ['MS-20', 'Jefferson, MS'],
  ['MS-21', 'Jefferson Davis, MS'],
  ['MS-22', 'Jones, MS'],
  ['MS-23', 'Kemper, MS'],
  ['MS-24', 'Lafayette, MS'],
  ['MS-25', 'Lamar, MS'],
  ['MS-26', 'Lauderdale, MS'],
  ['MS-27', 'Lawrence, MS'],
  ['MS-28', 'Leake, MS'],
  ['MS-29', 'Lee, MS'],
  ['MS-2A', 'Leflore, MS'],
  ['MS-2B', 'Lincoln, MS'],
  ['MS-2C', 'Lowndes, MS'],
  ['MS-2D', 'Madison, MS'],
  ['MS-2E', 'Marion, MS'],
  ['MS-2F', 'Marshall, MS'],
  ['MS-30', 'Monroe, MS'],
  ['MS-31', 'Montgomery, MS'],
  ['MS-32', 'Neshoba, MS'],
  ['MS-33', 'Newton, MS'],
  ['MS-34', 'Noxubee, MS'],
  ['MS-35', 'Oktibbeha, MS'],
  ['MS-36', 'Panola, MS'],
  ['MS-37', 'Pearl River, MS'],
  ['MS-38', 'Perry, MS'],
  ['MS-39', 'Pike, MS'],
  ['MS-3A', 'Pontotoc, MS'],
  ['MS-3B', 'Prentiss, MS'],
  ['MS-3C', 'Quitman, MS'],
  ['MS-3D', 'Rankin, MS'],
  ['MS-3E', 'Scott, MS'],
  ['MS-3F', 'Sharkey, MS'],
  ['MS-40', 'Simpson, MS'],
  ['MS-41', 'Smith, MS'],
  ['MS-42', 'Stone, MS'],
  ['MS-43', 'Sunflower, MS'],
  ['MS-44', 'Tallahatchie, MS'],
  ['MS-45', 'Tate, MS'],
  ['MS-46', 'Tippah, MS'],
  ['MS-47', 'Tishomingo, MS'],
  ['MS-48', 'Tunica, MS'],
  ['MS-49', 'Union, MS'],
  ['MS-4A', 'Walthall, MS'],
  ['MS-4B', 'Warren, MS'],
  ['MS-4C', 'Washington, MS'],
  ['MS-4D', 'Wayne, MS'],
  ['MS-4E', 'Webster, MS'],
  ['MS-4F', 'Wilkinson, MS'],
  ['MS-50', 'Winston, MS'],
  ['MS-51', 'Yalobusha, MS'],
  ['MS-52', 'Yazoo, MS'],
  ['MO-01', 'Adair, MO'],
  ['MO-02', 'Andrew, MO'],
  ['MO-03', 'Atchison, MO'],
  ['MO-04', 'Audrain, MO'],
  ['MO-05', 'Barry, MO'],
  ['MO-06', 'Barton, MO'],
  ['MO-07', 'Bates, MO'],
  ['MO-08', 'Benton, MO'],
  ['MO-09', 'Bollinger, MO'],
  ['MO-0A', 'Boone, MO'],
  ['MO-0B', 'Buchanan, MO'],
  ['MO-0C', 'Butler, MO'],
  ['MO-0D', 'Caldwell, MO'],
  ['MO-0E', 'Callaway, MO'],
  ['MO-0F', 'Camden, MO'],
  ['MO-10', 'Cape Girardeau, MO'],
  ['MO-11', 'Carroll, MO'],
  ['MO-12', 'Carter, MO'],
  ['MO-13', 'Cass, MO'],
  ['MO-14', 'Cedar, MO'],
  ['MO-15', 'Chariton, MO'],
  ['MO-16', 'Christian, MO'],
  ['MO-17', 'Clark, MO'],
  ['MO-18', 'Clay, MO'],
  ['MO-19', 'Clinton, MO'],
  ['MO-1A', 'Cole, MO'],
  ['MO-1B', 'Cooper, MO'],
  ['MO-1C', 'Crawford, MO'],
  ['MO-1D', 'Dade, MO'],
  ['MO-1E', 'Dallas, MO'],
  ['MO-1F', 'Daviess, MO'],
  ['MO-20', 'DeKalb, MO'],
  ['MO-21', 'Dent, MO'],
  ['MO-22', 'Douglas, MO'],
  ['MO-23', 'Dunklin, MO'],
  ['MO-24', 'Franklin, MO'],
  ['MO-25', 'Gasconade, MO'],
  ['MO-26', 'Gentry, MO'],
  ['MO-27', 'Greene, MO'],
  ['MO-28', 'Grundy, MO'],
  ['MO-29', 'Harrison, MO'],
  ['MO-2A', 'Henry, MO'],
  ['MO-2B', 'Hickory, MO'],
  ['MO-2C', 'Holt, MO'],
  ['MO-2D', 'Howard, MO'],
  ['MO-2E', 'Howell, MO'],
  ['MO-2F', 'Iron, MO'],
  ['MO-30', 'Jackson, MO'],
  ['MO-31', 'Jasper, MO'],
  ['MO-32', 'Jefferson, MO'],
  ['MO-33', 'Johnson, MO'],
  ['MO-34', 'Knox, MO'],
  ['MO-35', 'Laclede, MO'],
  ['MO-36', 'Lafayette, MO'],
  ['MO-37', 'Lawrence, MO'],
  ['MO-38', 'Lewis, MO'],
  ['MO-39', 'Lincoln, MO'],
  ['MO-3A', 'Linn, MO'],
  ['MO-3B', 'Livingston, MO'],
  ['MO-3C', 'McDonald, MO'],
  ['MO-3D', 'Macon, MO'],
  ['MO-3E', 'Madison, MO'],
  ['MO-3F', 'Maries, MO'],
  ['MO-40', 'Marion, MO'],
  ['MO-41', 'Mercer, MO'],
  ['MO-42', 'Miller, MO'],
  ['MO-43', 'Mississippi, MO'],
  ['MO-44', 'Moniteau, MO'],
  ['MO-45', 'Monroe, MO'],
  ['MO-46', 'Montgomery, MO'],
  ['MO-47', 'Morgan, MO'],
  ['MO-48', 'New Madrid, MO'],
  ['MO-49', 'Newton, MO'],
  ['MO-4A', 'Nodaway, MO'],
  ['MO-4B', 'Oregon, MO'],
  ['MO-4C', 'Osage, MO'],
  ['MO-4D', 'Ozark, MO'],
  ['MO-4E', 'Pemiscot, MO'],
  ['MO-4F', 'Perry, MO'],
  ['MO-50', 'Pettis, MO'],
  ['MO-51', 'Phelps, MO'],
  ['MO-52', 'Pike, MO'],
  ['MO-53', 'Platte, MO'],
  ['MO-54', 'Polk, MO'],
  ['MO-55', 'Pulaski, MO'],
  ['MO-56', 'Putnam, MO'],
  ['MO-57', 'Ralls, MO'],
  ['MO-58', 'Randolph, MO'],
  ['MO-59', 'Ray, MO'],
  ['MO-5A', 'Reynolds, MO'],
  ['MO-5B', 'Ripley, MO'],
  ['MO-5C', 'St. Charles, MO'],
  ['MO-5D', 'St. Clair, MO'],
  ['MO-5E', 'Ste. Genevieve, MO'],
  ['MO-5F', 'St. Francois, MO'],
  ['MO-60', 'St. Louis, MO'],
  ['MO-61', 'Saline, MO'],
  ['MO-62', 'Schuyler, MO'],
  ['MO-63', 'Scotland, MO'],
  ['MO-64', 'Scott, MO'],
  ['MO-65', 'Shannon, MO'],
  ['MO-66', 'Shelby, MO'],
  ['MO-67', 'Stoddard, MO'],
  ['MO-68', 'Stone, MO'],
  ['MO-69', 'Sullivan, MO'],
  ['MO-6A', 'Taney, MO'],
  ['MO-6B', 'Texas, MO'],
  ['MO-6C', 'Vernon, MO'],
  ['MO-6D', 'Warren, MO'],
  ['MO-6E', 'Washington, MO'],
  ['MO-6F', 'Wayne, MO'],
  ['MO-70', 'Webster, MO'],
  ['MO-71', 'Worth, MO'],
  ['MO-72', 'Wright, MO'],
  ['MO-73', 'St. Louis City, MO'],
  ['MT-01', 'Beaverhead, MT'],
  ['MT-02', 'Big Horn, MT'],
  ['MT-03', 'Blaine, MT'],
  ['MT-04', 'Broadwater, MT'],
  ['MT-05', 'Carbon, MT'],
  ['MT-06', 'Carter, MT'],
  ['MT-07', 'Cascade, MT'],
  ['MT-08', 'Chouteau, MT'],
  ['MT-09', 'Custer, MT'],
  ['MT-0A', 'Daniels, MT'],
  ['MT-0B', 'Dawson, MT'],
  ['MT-0C', 'Deer Lodge, MT'],
  ['MT-0D', 'Fallon, MT'],
  ['MT-0E', 'Fergus, MT'],
  ['MT-0F', 'Flathead, MT'],
  ['MT-10', 'Gallatin, MT'],
  ['MT-11', 'Garfield, MT'],
  ['MT-12', 'Glacier, MT'],
  ['MT-13', 'Golden Valley, MT'],
  ['MT-14', 'Granite, MT'],
  ['MT-15', 'Hill, MT'],
  ['MT-16', 'Jefferson, MT'],
  ['MT-17', 'Judith Basin, MT'],
  ['MT-18', 'Lake, MT'],
  ['MT-19', 'Lewis and Clark, MT'],
  ['MT-1A', 'Liberty, MT'],
  ['MT-1B', 'Lincoln, MT'],
  ['MT-1C', 'McCone, MT'],
  ['MT-1D', 'Madison, MT'],
  ['MT-1E', 'Meagher, MT'],
  ['MT-1F', 'Mineral, MT'],
  ['MT-20', 'Missoula, MT'],
  ['MT-21', 'Musselshell, MT'],
  ['MT-22', 'Park, MT'],
  ['MT-23', 'Petroleum, MT'],
  ['MT-24', 'Phillips, MT'],
  ['MT-25', 'Pondera, MT'],
  ['MT-26', 'Powder River, MT'],
  ['MT-27', 'Powell, MT'],
  ['MT-28', 'Prairie, MT'],
  ['MT-29', 'Ravalli, MT'],
  ['MT-2A', 'Richland, MT'],
  ['MT-2B', 'Roosevelt, MT'],
  ['MT-2C', 'Rosebud, MT'],
  ['MT-2D', 'Sanders, MT'],
  ['MT-2E', 'Sheridan, MT'],
  ['MT-2F', 'Silver Bow, MT'],
  ['MT-30', 'Stillwater, MT'],
  ['MT-31', 'Sweet Grass, MT'],
  ['MT-32', 'Teton, MT'],
  ['MT-33', 'Toole, MT'],
  ['MT-34', 'Treasure, MT'],
  ['MT-35', 'Valley, MT'],
  ['MT-36', 'Wheatland, MT'],
  ['MT-37', 'Wibaux, MT'],
  ['MT-38', 'Yellowstone, MT'],
  ['NE-01', 'Adams, NE'],
  ['NE-02', 'Antelope, NE'],
  ['NE-03', 'Arthur, NE'],
  ['NE-04', 'Banner, NE'],
  ['NE-05', 'Blaine, NE'],
  ['NE-06', 'Boone, NE'],
  ['NE-07', 'Box Butte, NE'],
  ['NE-08', 'Boyd, NE'],
  ['NE-09', 'Brown, NE'],
  ['NE-0A', 'Buffalo, NE'],
  ['NE-0B', 'Burt, NE'],
  ['NE-0C', 'Butler, NE'],
  ['NE-0D', 'Cass, NE'],
  ['NE-0E', 'Cedar, NE'],
  ['NE-0F', 'Chase, NE'],
  ['NE-10', 'Cherry, NE'],
  ['NE-11', 'Cheyenne, NE'],
  ['NE-12', 'Clay, NE'],
  ['NE-13', 'Colfax, NE'],
  ['NE-14', 'Cuming, NE'],
  ['NE-15', 'Custer, NE'],
  ['NE-16', 'Dakota, NE'],
  ['NE-17', 'Dawes, NE'],
  ['NE-18', 'Dawson, NE'],
  ['NE-19', 'Deuel, NE'],
  ['NE-1A', 'Dixon, NE'],
  ['NE-1B', 'Dodge, NE'],
  ['NE-1C', 'Douglas, NE'],
  ['NE-1D', 'Dundy, NE'],
  ['NE-1E', 'Fillmore, NE'],
  ['NE-1F', 'Franklin, NE'],
  ['NE-20', 'Frontier, NE'],
  ['NE-21', 'Furnas, NE'],
  ['NE-22', 'Gage, NE'],
  ['NE-23', 'Garden, NE'],
  ['NE-24', 'Garfield, NE'],
  ['NE-25', 'Gosper, NE'],
  ['NE-26', 'Grant, NE'],
  ['NE-27', 'Greeley, NE'],
  ['NE-28', 'Hall, NE'],
  ['NE-29', 'Hamilton, NE'],
  ['NE-2A', 'Harlan, NE'],
  ['NE-2B', 'Hayes, NE'],
  ['NE-2C', 'Hitchcock, NE'],
  ['NE-2D', 'Holt, NE'],
  ['NE-2E', 'Hooker, NE'],
  ['NE-2F', 'Howard, NE'],
  ['NE-30', 'Jefferson, NE'],
  ['NE-31', 'Johnson, NE'],
  ['NE-32', 'Kearney, NE'],
  ['NE-33', 'Keith, NE'],
  ['NE-34', 'Keya Paha, NE'],
  ['NE-35', 'Kimball, NE'],
  ['NE-36', 'Knox, NE'],
  ['NE-37', 'Lancaster, NE'],
  ['NE-38', 'Lincoln, NE'],
  ['NE-39', 'Logan, NE'],
  ['NE-3A', 'Loup, NE'],
  ['NE-3B', 'McPherson, NE'],
  ['NE-3C', 'Madison, NE'],
  ['NE-3D', 'Merrick, NE'],
  ['NE-3E', 'Morrill, NE'],
  ['NE-3F', 'Nance, NE'],
  ['NE-40', 'Nemaha, NE'],
  ['NE-41', 'Nuckolls, NE'],
  ['NE-42', 'Otoe, NE'],
  ['NE-43', 'Pawnee, NE'],
  ['NE-44', 'Perkins, NE'],
  ['NE-45', 'Phelps, NE'],
  ['NE-46', 'Pierce, NE'],
  ['NE-47', 'Platte, NE'],
  ['NE-48', 'Polk, NE'],
  ['NE-49', 'Red Willow, NE'],
  ['NE-4A', 'Richardson, NE'],
  ['NE-4B', 'Rock, NE'],
  ['NE-4C', 'Saline, NE'],
  ['NE-4D', 'Sarpy, NE'],
  ['NE-4E', 'Saunders, NE'],
  ['NE-4F', 'Scotts Bluff, NE'],
  ['NE-50', 'Seward, NE'],
  ['NE-51', 'Sheridan, NE'],
  ['NE-52', 'Sherman, NE'],
  ['NE-53', 'Sioux, NE'],
  ['NE-54', 'Stanton, NE'],
  ['NE-55', 'Thayer, NE'],
  ['NE-56', 'Thomas, NE'],
  ['NE-57', 'Thurston, NE'],
  ['NE-58', 'Valley, NE'],
  ['NE-59', 'Washington, NE'],
  ['NE-5A', 'Wayne, NE'],
  ['NE-5B', 'Webster, NE'],
  ['NE-5C', 'Wheeler, NE'],
  ['NE-5D', 'York, NE'],
  ['NV-01', 'Churchill, NV'],
  ['NV-02', 'Clark, NV'],
  ['NV-03', 'Douglas, NV'],
  ['NV-04', 'Elko, NV'],
  ['NV-05', 'Esmeralda, NV'],
  ['NV-06', 'Eureka, NV'],
  ['NV-07', 'Humboldt, NV'],
  ['NV-08', 'Lander, NV'],
  ['NV-09', 'Lincoln, NV'],
  ['NV-0A', 'Lyon, NV'],
  ['NV-0B', 'Mineral, NV'],
  ['NV-0C', 'Nye, NV'],
  ['NV-0D', 'Pershing, NV'],
  ['NV-0E', 'Storey, NV'],
  ['NV-0F', 'Washoe, NV'],
  ['NV-10', 'White Pine, NV'],
  ['NV-11', 'Carson City, NV'],
  ['NH-01', 'Belknap, NH'],
  ['NH-02', 'Carroll, NH'],
  ['NH-03', 'Cheshire, NH'],
  ['NH-04', 'Coos, NH'],
  ['NH-05', 'Grafton, NH'],
  ['NH-06', 'Hillsborough, NH'],
  ['NH-07', 'Merrimack, NH'],
  ['NH-08', 'Rockingham, NH'],
  ['NH-09', 'Strafford, NH'],
  ['NH-0A', 'Sullivan, NH'],
  ['NJ-01', 'Atlantic, NJ'],
  ['NJ-02', 'Bergen, NJ'],
  ['NJ-03', 'Burlington, NJ'],
  ['NJ-04', 'Camden, NJ'],
  ['NJ-05', 'Cape May, NJ'],
  ['NJ-06', 'Cumberland, NJ'],
  ['NJ-07', 'Essex, NJ'],
  ['NJ-08', 'Gloucester, NJ'],
  ['NJ-09', 'Hudson, NJ'],
  ['NJ-0A', 'Hunterdon, NJ'],
  ['NJ-0B', 'Mercer, NJ'],
  ['NJ-0C', 'Middlesex, NJ'],
  ['NJ-0D', 'Monmouth, NJ'],
  ['NJ-0E', 'Morris, NJ'],
  ['NJ-0F', 'Ocean, NJ'],
  ['NJ-10', 'Passaic, NJ'],
  ['NJ-11', 'Salem, NJ'],
  ['NJ-12', 'Somerset, NJ'],
  ['NJ-13', 'Sussex, NJ'],
  ['NJ-14', 'Union, NJ'],
  ['NJ-15', 'Warren, NJ'],
  ['NM-01', 'Bernalillo, NM'],
  ['NM-02', 'Catron, NM'],
  ['NM-03', 'Chaves, NM'],
  ['NM-04', 'Cibola, NM'],
  ['NM-05', 'Colfax, NM'],
  ['NM-06', 'Curry, NM'],
  ['NM-07', 'De Baca, NM'],
  ['NM-08', 'Dona Ana, NM'],
  ['NM-09', 'Eddy, NM'],
  ['NM-0A', 'Grant, NM'],
  ['NM-0B', 'Guadalupe, NM'],
  ['NM-0C', 'Harding, NM'],
  ['NM-0D', 'Hidalgo, NM'],
  ['NM-0E', 'Lea, NM'],
  ['NM-0F', 'Lincoln, NM'],
  ['NM-10', 'Los Alamos, NM'],
  ['NM-11', 'Luna, NM'],
  ['NM-12', 'McKinley, NM'],
  ['NM-13', 'Mora, NM'],
  ['NM-14', 'Otero, NM'],
  ['NM-15', 'Quay, NM'],
  ['NM-16', 'Rio Arriba, NM'],
  ['NM-17', 'Roosevelt, NM'],
  ['NM-18', 'Sandoval, NM'],
  ['NM-19', 'San Juan, NM'],
  ['NM-1A', 'San Miguel, NM'],
  ['NM-1B', 'Santa Fe, NM'],
  ['NM-1C', 'Sierra, NM'],
  ['NM-1D', 'Socorro, NM'],
  ['NM-1E', 'Taos, NM'],
  ['NM-1F', 'Torrance, NM'],
  ['NM-20', 'Union, NM'],
  ['NM-21', 'Valencia, NM'],
  ['NY-01', 'Albany, NY'],
  ['NY-02', 'Allegany, NY'],
  ['NY-03', 'Bronx, NY'],
  ['NY-04', 'Broome, NY'],
  ['NY-05', 'Cattaraugus, NY'],
  ['NY-06', 'Cayuga, NY'],
  ['NY-07', 'Chautauqua, NY'],
  ['NY-08', 'Chemung, NY'],
  ['NY-09', 'Chenango, NY'],
  ['NY-0A', 'Clinton, NY'],
  ['NY-0B', 'Columbia, NY'],
  ['NY-0C', 'Cortland, NY'],
  ['NY-0D', 'Delaware, NY'],
  ['NY-0E', 'Dutchess, NY'],
  ['NY-0F', 'Erie, NY'],
  ['NY-10', 'Essex, NY'],
  ['NY-11', 'Franklin, NY'],
  ['NY-12', 'Fulton, NY'],
  ['NY-13', 'Genesee, NY'],
  ['NY-14', 'Greene, NY'],
  ['NY-15', 'Hamilton, NY'],
  ['NY-16', 'Herkimer, NY'],
  ['NY-17', 'Jefferson, NY'],
  ['NY-18', 'Kings, NY'],
  ['NY-19', 'Lewis, NY'],
  ['NY-1A', 'Livingston, NY'],
  ['NY-1B', 'Madison, NY'],
  ['NY-1C', 'Monroe, NY'],
  ['NY-1D', 'Montgomery, NY'],
  ['NY-1E', 'Nassau, NY'],
  ['NY-1F', 'New York, NY'],
  ['NY-20', 'Niagara, NY'],
  ['NY-21', 'Oneida, NY'],
  ['NY-22', 'Onondaga, NY'],
  ['NY-23', 'Ontario, NY'],
  ['NY-24', 'Orange, NY'],
  ['NY-25', 'Orleans, NY'],
  ['NY-26', 'Oswego, NY'],
  ['NY-27', 'Otsego, NY'],
  ['NY-28', 'Putnam, NY'],
  ['NY-29', 'Queens, NY'],
  ['NY-2A', 'Rensselaer, NY'],
  ['NY-2B', 'Richmond, NY'],
  ['NY-2C', 'Rockland, NY'],
  ['NY-2D', 'St. Lawrence, NY'],
  ['NY-2E', 'Saratoga, NY'],
  ['NY-2F', 'Schenectady, NY'],
  ['NY-30', 'Schoharie, NY'],
  ['NY-31', 'Schuyler, NY'],
  ['NY-32', 'Seneca, NY'],
  ['NY-33', 'Steuben, NY'],
  ['NY-34', 'Suffolk, NY'],
  ['NY-35', 'Sullivan, NY'],
  ['NY-36', 'Tioga, NY'],
  ['NY-37', 'Tompkins, NY'],
  ['NY-38', 'Ulster, NY'],
  ['NY-39', 'Warren, NY'],
  ['NY-3A', 'Washington, NY'],
  ['NY-3B', 'Wayne, NY'],
  ['NY-3C', 'Westchester, NY'],
  ['NY-3D', 'Wyoming, NY'],
  ['NY-3E', 'Yates, NY'],
  ['NC-01', 'Alamance, NC'],
  ['NC-02', 'Alexander, NC'],
  ['NC-03', 'Alleghany, NC'],
  ['NC-04', 'Anson, NC'],
  ['NC-05', 'Ashe, NC'],
  ['NC-06', 'Avery, NC'],
  ['NC-07', 'Beaufort, NC'],
  ['NC-08', 'Bertie, NC'],
  ['NC-09', 'Bladen, NC'],
  ['NC-0A', 'Brunswick, NC'],
  ['NC-0B', 'Buncombe, NC'],
  ['NC-0C', 'Burke, NC'],
  ['NC-0D', 'Cabarrus, NC'],
  ['NC-0E', 'Caldwell, NC'],
  ['NC-0F', 'Camden, NC'],
  ['NC-10', 'Carteret, NC'],
  ['NC-11', 'Caswell, NC'],
  ['NC-12', 'Catawba, NC'],
  ['NC-13', 'Chatham, NC'],
  ['NC-14', 'Cherokee, NC'],
  ['NC-15', 'Chowan, NC'],
  ['NC-16', 'Clay, NC'],
  ['NC-17', 'Cleveland, NC'],
  ['NC-18', 'Columbus, NC'],
  ['NC-19', 'Craven, NC'],
  ['NC-1A', 'Cumberland, NC'],
  ['NC-1B', 'Currituck, NC'],
  ['NC-1C', 'Dare, NC'],
  ['NC-1D', 'Davidson, NC'],
  ['NC-1E', 'Davie, NC'],
  ['NC-1F', 'Duplin, NC'],
  ['NC-20', 'Durham, NC'],
  ['NC-21', 'Edgecombe, NC'],
  ['NC-22', 'Forsyth, NC'],
  ['NC-23', 'Franklin, NC'],
  ['NC-24', 'Gaston, NC'],
  ['NC-25', 'Gates, NC'],
  ['NC-26', 'Graham, NC'],
  ['NC-27', 'Granville, NC'],
  ['NC-28', 'Greene, NC'],
  ['NC-29', 'Guilford, NC'],
  ['NC-2A', 'Halifax, NC'],
  ['NC-2B', 'Harnett, NC'],
  ['NC-2C', 'Haywood, NC'],
  ['NC-2D', 'Henderson, NC'],
  ['NC-2E', 'Hertford, NC'],
  ['NC-2F', 'Hoke, NC'],
  ['NC-30', 'Hyde, NC'],
  ['NC-31', 'Iredell, NC'],
  ['NC-32', 'Jackson, NC'],
  ['NC-33', 'Johnston, NC'],
  ['NC-34', 'Jones, NC'],
  ['NC-35', 'Lee, NC'],
  ['NC-36', 'Lenoir, NC'],
  ['NC-37', 'Lincoln, NC'],
  ['NC-38', 'McDowell, NC'],
  ['NC-39', 'Macon, NC'],
  ['NC-3A', 'Madison, NC'],
  ['NC-3B', 'Martin, NC'],
  ['NC-3C', 'Mecklenburg, NC'],
  ['NC-3D', 'Mitchell, NC'],
  ['NC-3E', 'Montgomery, NC'],
  ['NC-3F', 'Moore, NC'],
  ['NC-40', 'Nash, NC'],
  ['NC-41', 'New Hanover, NC'],
  ['NC-42', 'Northampton, NC'],
  ['NC-43', 'Onslow, NC'],
  ['NC-44', 'Orange, NC'],
  ['NC-45', 'Pamlico, NC'],
  ['NC-46', 'Pasquotank, NC'],
  ['NC-47', 'Pender, NC'],
  ['NC-48', 'Perquimans, NC'],
  ['NC-49', 'Person, NC'],
  ['NC-4A', 'Pitt, NC'],
  ['NC-4B', 'Polk, NC'],
  ['NC-4C', 'Randolph, NC'],
  ['NC-4D', 'Richmond, NC'],
  ['NC-4E', 'Robeson, NC'],
  ['NC-4F', 'Rockingham, NC'],
  ['NC-50', 'Rowan, NC'],
  ['NC-51', 'Rutherford, NC'],
  ['NC-52', 'Sampson, NC'],
  ['NC-53', 'Scotland, NC'],
  ['NC-54', 'Stanly, NC'],
  ['NC-55', 'Stokes, NC'],
  ['NC-56', 'Surry, NC'],
  ['NC-57', 'Swain, NC'],
  ['NC-58', 'Transylvania, NC'],
  ['NC-59', 'Tyrrell, NC'],
  ['NC-5A', 'Union, NC'],
  ['NC-5B', 'Vance, NC'],
  ['NC-5C', 'Wake, NC'],
  ['NC-5D', 'Warren, NC'],
  ['NC-5E', 'Washington, NC'],
  ['NC-5F', 'Watauga, NC'],
  ['NC-60', 'Wayne, NC'],
  ['NC-61', 'Wilkes, NC'],
  ['NC-62', 'Wilson, NC'],
  ['NC-63', 'Yadkin, NC'],
  ['NC-64', 'Yancey, NC'],
  ['ND-01', 'Adams, ND'],
  ['ND-02', 'Barnes, ND'],
  ['ND-03', 'Benson, ND'],
  ['ND-04', 'Billings, ND'],
  ['ND-05', 'Bottineau, ND'],
  ['ND-06', 'Bowman, ND'],
  ['ND-07', 'Burke, ND'],
  ['ND-08', 'Burleigh, ND'],
  ['ND-09', 'Cass, ND'],
  ['ND-0A', 'Cavalier, ND'],
  ['ND-0B', 'Dickey, ND'],
  ['ND-0C', 'Divide, ND'],
  ['ND-0D', 'Dunn, ND'],
  ['ND-0E', 'Eddy, ND'],
  ['ND-0F', 'Emmons, ND'],
  ['ND-10', 'Foster, ND'],
  ['ND-11', 'Golden Valley, ND'],
  ['ND-12', 'Grand Forks, ND'],
  ['ND-13', 'Grant, ND'],
  ['ND-14', 'Griggs, ND'],
  ['ND-15', 'Hettinger, ND'],
  ['ND-16', 'Kidder, ND'],
  ['ND-17', 'LaMoure, ND'],
  ['ND-18', 'Logan, ND'],
  ['ND-19', 'McHenry, ND'],
  ['ND-1A', 'McIntosh, ND'],
  ['ND-1B', 'McKenzie, ND'],
  ['ND-1C', 'McLean, ND'],
  ['ND-1D', 'Mercer, ND'],
  ['ND-1E', 'Morton, ND'],
  ['ND-1F', 'Mountrail, ND'],
  ['ND-20', 'Nelson, ND'],
  ['ND-21', 'Oliver, ND'],
  ['ND-22', 'Pembina, ND'],
  ['ND-23', 'Pierce, ND'],
  ['ND-24', 'Ramsey, ND'],
  ['ND-25', 'Ransom, ND'],
  ['ND-26', 'Renville, ND'],
  ['ND-27', 'Richland, ND'],
  ['ND-28', 'Rolette, ND'],
  ['ND-29', 'Sargent, ND'],
  ['ND-2A', 'Sheridan, ND'],
  ['ND-2B', 'Sioux, ND'],
  ['ND-2C', 'Slope, ND'],
  ['ND-2D', 'Stark, ND'],
  ['ND-2E', 'Steele, ND'],
  ['ND-2F', 'Stutsman, ND'],
  ['ND-30', 'Towner, ND'],
  ['ND-31', 'Traill, ND'],
  ['ND-32', 'Walsh, ND'],
  ['ND-33', 'Ward, ND'],
  ['ND-34', 'Wells, ND'],
  ['ND-35', 'Williams, ND'],
  ['OH-01', 'Adams, OH'],
  ['OH-02', 'Allen, OH'],
  ['OH-03', 'Ashland, OH'],
  ['OH-04', 'Ashtabula, OH'],
  ['OH-05', 'Athens, OH'],
  ['OH-06', 'Auglaize, OH'],
  ['OH-07', 'Belmont, OH'],
  ['OH-08', 'Brown, OH'],
  ['OH-09', 'Butler, OH'],
  ['OH-0A', 'Carroll, OH'],
  ['OH-0B', 'Champaign, OH'],
  ['OH-0C', 'Clark, OH'],
  ['OH-0D', 'Clermont, OH'],
  ['OH-0E', 'Clinton, OH'],
  ['OH-0F', 'Columbiana, OH'],
  ['OH-10', 'Coshocton, OH'],
  ['OH-11', 'Crawford, OH'],
  ['OH-12', 'Cuyahoga, OH'],
  ['OH-13', 'Darke, OH'],
  ['OH-14', 'Defiance, OH'],
  ['OH-15', 'Delaware, OH'],
  ['OH-16', 'Erie, OH'],
  ['OH-17', 'Fairfield, OH'],
  ['OH-18', 'Fayette, OH'],
  ['OH-19', 'Franklin, OH'],
  ['OH-1A', 'Fulton, OH'],
  ['OH-1B', 'Gallia, OH'],
  ['OH-1C', 'Geauga, OH'],
  ['OH-1D', 'Greene, OH'],
  ['OH-1E', 'Guernsey, OH'],
  ['OH-1F', 'Hamilton, OH'],
  ['OH-20', 'Hancock, OH'],
  ['OH-21', 'Hardin, OH'],
  ['OH-22', 'Harrison, OH'],
  ['OH-23', 'Henry, OH'],
  ['OH-24', 'Highland, OH'],
  ['OH-25', 'Hocking, OH'],
  ['OH-26', 'Holmes, OH'],
  ['OH-27', 'Huron, OH'],
  ['OH-28', 'Jackson, OH'],
  ['OH-29', 'Jefferson, OH'],
  ['OH-2A', 'Knox, OH'],
  ['OH-2B', 'Lake, OH'],
  ['OH-2C', 'Lawrence, OH'],
  ['OH-2D', 'Licking, OH'],
  ['OH-2E', 'Logan, OH'],
  ['OH-2F', 'Lorain, OH'],
  ['OH-30', 'Lucas, OH'],
  ['OH-31', 'Madison, OH'],
  ['OH-32', 'Mahoning, OH'],
  ['OH-33', 'Marion, OH'],
  ['OH-34', 'Medina, OH'],
  ['OH-35', 'Meigs, OH'],
  ['OH-36', 'Mercer, OH'],
  ['OH-37', 'Miami, OH'],
  ['OH-38', 'Monroe, OH'],
  ['OH-39', 'Montgomery, OH'],
  ['OH-3A', 'Morgan, OH'],
  ['OH-3B', 'Morrow, OH'],
  ['OH-3C', 'Muskingum, OH'],
  ['OH-3D', 'Noble, OH'],
  ['OH-3E', 'Ottawa, OH'],
  ['OH-3F', 'Paulding, OH'],
  ['OH-40', 'Perry, OH'],
  ['OH-41', 'Pickaway, OH'],
  ['OH-42', 'Pike, OH'],
  ['OH-43', 'Portage, OH'],
  ['OH-44', 'Preble, OH'],
  ['OH-45', 'Putnam, OH'],
  ['OH-46', 'Richland, OH'],
  ['OH-47', 'Ross, OH'],
  ['OH-48', 'Sandusky, OH'],
  ['OH-49', 'Scioto, OH'],
  ['OH-4A', 'Seneca, OH'],
  ['OH-4B', 'Shelby, OH'],
  ['OH-4C', 'Stark, OH'],
  ['OH-4D', 'Summit, OH'],
  ['OH-4E', 'Trumbull, OH'],
  ['OH-4F', 'Tuscarawas, OH'],
  ['OH-50', 'Union, OH'],
  ['OH-51', 'Van Wert, OH'],
  ['OH-52', 'Vinton, OH'],
  ['OH-53', 'Warren, OH'],
  ['OH-54', 'Washington, OH'],
  ['OH-55', 'Wayne, OH'],
  ['OH-56', 'Williams, OH'],
  ['OH-57', 'Wood, OH'],
  ['OH-58', 'Wyandot, OH'],
  ['OK-01', 'Adair, OK'],
  ['OK-02', 'Alfalfa, OK'],
  ['OK-03', 'Atoka, OK'],
  ['OK-04', 'Beaver, OK'],
  ['OK-05', 'Beckham, OK'],
  ['OK-06', 'Blaine, OK'],
  ['OK-07', 'Bryan, OK'],
  ['OK-08', 'Caddo, OK'],
  ['OK-09', 'Canadian, OK'],
  ['OK-0A', 'Carter, OK'],
  ['OK-0B', 'Cherokee, OK'],
  ['OK-0C', 'Choctaw, OK'],
  ['OK-0D', 'Cimarron, OK'],
  ['OK-0E', 'Cleveland, OK'],
  ['OK-0F', 'Coal, OK'],
  ['OK-10', 'Comanche, OK'],
  ['OK-11', 'Cotton, OK'],
  ['OK-12', 'Craig, OK'],
  ['OK-13', 'Creek, OK'],
  ['OK-14', 'Custer, OK'],
  ['OK-15', 'Delaware, OK'],
  ['OK-16', 'Dewey, OK'],
  ['OK-17', 'Ellis, OK'],
  ['OK-18', 'Garfield, OK'],
  ['OK-19', 'Garvin, OK'],
  ['OK-1A', 'Grady, OK'],
  ['OK-1B', 'Grant, OK'],
  ['OK-1C', 'Greer, OK'],
  ['OK-1D', 'Harmon, OK'],
  ['OK-1E', 'Harper, OK'],
  ['OK-1F', 'Haskell, OK'],
  ['OK-20', 'Hughes, OK'],
  ['OK-21', 'Jackson, OK'],
  ['OK-22', 'Jefferson, OK'],
  ['OK-23', 'Johnston, OK'],
  ['OK-24', 'Kay, OK'],
  ['OK-25', 'Kingfisher, OK'],
  ['OK-26', 'Kiowa, OK'],
  ['OK-27', 'Latimer, OK'],
  ['OK-28', 'Le Flore, OK'],
  ['OK-29', 'Lincoln, OK'],
  ['OK-2A', 'Logan, OK'],
  ['OK-2B', 'Love, OK'],
  ['OK-2C', 'McClain, OK'],
  ['OK-2D', 'McCurtain, OK'],
  ['OK-2E', 'McIntosh, OK'],
  ['OK-2F', 'Major, OK'],
  ['OK-30', 'Marshall, OK'],
  ['OK-31', 'Mayes, OK'],
  ['OK-32', 'Murray, OK'],
  ['OK-33', 'Muskogee, OK'],
  ['OK-34', 'Noble, OK'],
  ['OK-35', 'Nowata, OK'],
  ['OK-36', 'Okfuskee, OK'],
  ['OK-37', 'Oklahoma, OK'],
  ['OK-38', 'Okmulgee, OK'],
  ['OK-39', 'Osage, OK'],
  ['OK-3A', 'Ottawa, OK'],
  ['OK-3B', 'Pawnee, OK'],
  ['OK-3C', 'Payne, OK'],
  ['OK-3D', 'Pittsburg, OK'],
  ['OK-3E', 'Pontotoc, OK'],
  ['OK-3F', 'Pottawatomie, OK'],
  ['OK-40', 'Pushmataha, OK'],
  ['OK-41', 'Roger Mills, OK'],
  ['OK-42', 'Rogers, OK'],
  ['OK-43', 'Seminole, OK'],
  ['OK-44', 'Sequoyah, OK'],
  ['OK-45', 'Stephens, OK'],
  ['OK-46', 'Texas, OK'],
  ['OK-47', 'Tillman, OK'],
  ['OK-48', 'Tulsa, OK'],
  ['OK-49', 'Wagoner, OK'],
  ['OK-4A', 'Washington, OK'],
  ['OK-4B', 'Washita, OK'],
  ['OK-4C', 'Woods, OK'],
  ['OK-4D', 'Woodward, OK'],
  ['OR-01', 'Baker, OR'],
  ['OR-02', 'Benton, OR'],
  ['OR-03', 'Clackamas, OR'],
  ['OR-04', 'Clatsop, OR'],
  ['OR-05', 'Columbia, OR'],
  ['OR-06', 'Coos, OR'],
  ['OR-07', 'Crook, OR'],
  ['OR-08', 'Curry, OR'],
  ['OR-09', 'Deschutes, OR'],
  ['OR-0A', 'Douglas, OR'],
  ['OR-0B', 'Gilliam, OR'],
  ['OR-0C', 'Grant, OR'],
  ['OR-0D', 'Harney, OR'],
  ['OR-0E', 'Hood River, OR'],
  ['OR-0F', 'Jackson, OR'],
  ['OR-10', 'Jefferson, OR'],
  ['OR-11', 'Josephine, OR'],
  ['OR-12', 'Klamath, OR'],
  ['OR-13', 'Lake, OR'],
  ['OR-14', 'Lane, OR'],
  ['OR-15', 'Lincoln, OR'],
  ['OR-16', 'Linn, OR'],
  ['OR-17', 'Malheur, OR'],
  ['OR-18', 'Marion, OR'],
  ['OR-19', 'Morrow, OR'],
  ['OR-1A', 'Multnomah, OR'],
  ['OR-1B', 'Polk, OR'],
  ['OR-1C', 'Sherman, OR'],
  ['OR-1D', 'Tillamook, OR'],
  ['OR-1E', 'Umatilla, OR'],
  ['OR-1F', 'Union, OR'],
  ['OR-20', 'Wallowa, OR'],
  ['OR-21', 'Wasco, OR'],
  ['OR-22', 'Washington, OR'],
  ['OR-23', 'Wheeler, OR'],
  ['OR-24', 'Yamhill, OR'],
  ['PA-01', 'Adams, PA'],
  ['PA-02', 'Allegheny, PA'],
  ['PA-03', 'Armstrong, PA'],
  ['PA-04', 'Beaver, PA'],
  ['PA-05', 'Bedford, PA'],
  ['PA-06', 'Berks, PA'],
  ['PA-07', 'Blair, PA'],
  ['PA-08', 'Bradford, PA'],
  ['PA-09', 'Bucks, PA'],
  ['PA-0A', 'Butler, PA'],
  ['PA-0B', 'Cambria, PA'],
  ['PA-0C', 'Cameron, PA'],
  ['PA-0D', 'Carbon, PA'],
  ['PA-0E', 'Centre, PA'],
  ['PA-0F', 'Chester, PA'],
  ['PA-10', 'Clarion, PA'],
  ['PA-11', 'Clearfield, PA'],
  ['PA-12', 'Clinton, PA'],
  ['PA-13', 'Columbia, PA'],
  ['PA-14', 'Crawford, PA'],
  ['PA-15', 'Cumberland, PA'],
  ['PA-16', 'Dauphin, PA'],
  ['PA-17', 'Delaware, PA'],
  ['PA-18', 'Elk, PA'],
  ['PA-19', 'Erie, PA'],
  ['PA-1A', 'Fayette, PA'],
  ['PA-1B', 'Forest, PA'],
  ['PA-1C', 'Franklin, PA'],
  ['PA-1D', 'Fulton, PA'],
  ['PA-1E', 'Greene, PA'],
  ['PA-1F', 'Huntingdon, PA'],
  ['PA-20', 'Indiana, PA'],
  ['PA-21', 'Jefferson, PA'],
  ['PA-22', 'Juniata, PA'],
  ['PA-23', 'Lackawanna, PA'],
  ['PA-24', 'Lancaster, PA'],
  ['PA-25', 'Lawrence, PA'],
  ['PA-26', 'Lebanon, PA'],
  ['PA-27', 'Lehigh, PA'],
  ['PA-28', 'Luzerne, PA'],
  ['PA-29', 'Lycoming, PA'],
  ['PA-2A', 'McKean, PA'],
  ['PA-2B', 'Mercer, PA'],
  ['PA-2C', 'Mifflin, PA'],
  ['PA-2D', 'Monroe, PA'],
  ['PA-2E', 'Montgomery, PA'],
  ['PA-2F', 'Montour, PA'],
  ['PA-30', 'Northampton, PA'],
  ['PA-31', 'Northumberland, PA'],
  ['PA-32', 'Perry, PA'],
  ['PA-33', 'Philadelphia, PA'],
  ['PA-34', 'Pike, PA'],
  ['PA-35', 'Potter, PA'],
  ['PA-36', 'Schuylkill, PA'],
  ['PA-37', 'Snyder, PA'],
  ['PA-38', 'Somerset, PA'],
  ['PA-39', 'Sullivan, PA'],
  ['PA-3A', 'Susquehanna, PA'],
  ['PA-3B', 'Tioga, PA'],
  ['PA-3C', 'Union, PA'],
  ['PA-3D', 'Venango, PA'],
  ['PA-3E', 'Warren, PA'],
  ['PA-3F', 'Washington, PA'],
  ['PA-40', 'Wayne, PA'],
  ['PA-41', 'Westmoreland, PA'],
  ['PA-42', 'Wyoming, PA'],
  ['PA-43', 'York, PA'],
  ['PR-01', 'Adjuntas, PR'],
  ['PR-02', 'Aguada, PR'],
  ['PR-03', 'Aguadilla, PR'],
  ['PR-04', 'Aguas Buenas, PR'],
  ['PR-05', 'Aibonito, PR'],
  ['PR-06', 'Añasco, PR'],
  ['PR-07', 'Arecibo, PR'],
  ['PR-08', 'Arroyo, PR'],
  ['PR-09', 'Barceloneta, PR'],
  ['PR-0A', 'Barranquitas, PR'],
  ['PR-0B', 'Bayamón, PR'],
  ['PR-0C', 'Cabo Rojo, PR'],
  ['PR-0D', 'Caguas, PR'],
  ['PR-0E', 'Camuy, PR'],
  ['PR-0F', 'Canóvanas, PR'],
  ['PR-10', 'Carolina, PR'],
  ['PR-11', 'Cataño, PR'],
  ['PR-12', 'Cayey, PR'],
  ['PR-13', 'Ceiba, PR'],
  ['PR-14', 'Ciales, PR'],
  ['PR-15', 'Cidra, PR'],
  ['PR-16', 'Coamo, PR'],
  ['PR-17', 'Comerío, PR'],
  ['PR-18', 'Corozal, PR'],
  ['PR-19', 'Culebra, PR'],
  ['PR-1A', 'Dorado, PR'],
  ['PR-1B', 'Fajardo, PR'],
  ['PR-1C', 'Florida, PR'],
  ['PR-1D', 'Guánica, PR'],
  ['PR-1E', 'Guayama, PR'],
  ['PR-1F', 'Guayanilla, PR'],
  ['PR-20', 'Guaynabo, PR'],
  ['PR-21', 'Gurabo, PR'],
  ['PR-22', 'Hatillo, PR'],
  ['PR-23', 'Hormigueros, PR'],
  ['PR-24', 'Humacao, PR'],
  ['PR-25', 'Isabela, PR'],
  ['PR-26', 'Jayuya, PR'],
  ['PR-27', 'Juana Díaz, PR'],
  ['PR-28', 'Juncos, PR'],
  ['PR-29', 'Lajas, PR'],
  ['PR-2A', 'Lares, PR'],
  ['PR-2B', 'Las Marías, PR'],
  ['PR-2C', 'Las Piedras, PR'],
  ['PR-2D', 'Loíza, PR'],
  ['PR-2E', 'Luquillo, PR'],
  ['PR-2F', 'Manatí, PR'],
  ['PR-30', 'Maricao, PR'],
  ['PR-31', 'Maunabo, PR'],
  ['PR-32', 'Mayagüez, PR'],
  ['PR-33', 'Moca, PR'],
  ['PR-34', 'Morovis, PR'],
  ['PR-35', 'Naguabo, PR'],
  ['PR-36', 'Naranjito, PR'],
  ['PR-37', 'Orocovis, PR'],
  ['PR-38', 'Patillas, PR'],
  ['PR-39', 'Peñuelas, PR'],
  ['PR-3A', 'Ponce, PR'],
  ['PR-3B', 'Quebradillas, PR'],
  ['PR-3C', 'Rincón, PR'],
  ['PR-3D', 'Río Grande, PR'],
  ['PR-3E', 'Sabana Grande, PR'],
  ['PR-3F', 'Salinas, PR'],
  ['PR-40', 'San Germán, PR'],
  ['PR-41', 'San Juan, PR'],
  ['PR-42', 'San Lorenzo, PR'],
  ['PR-43', 'San Sebastián, PR'],
  ['PR-44', 'Santa Isabel, PR'],
  ['PR-45', 'Toa Alta, PR'],
  ['PR-46', 'Toa Baja, PR'],
  ['PR-47', 'Trujillo Alto, PR'],
  ['PR-48', 'Utuado, PR'],
  ['PR-49', 'Vega Alta, PR'],
  ['PR-4A', 'Vega Baja, PR'],
  ['PR-4B', 'Vieques, PR'],
  ['PR-4C', 'Villalba, PR'],
  ['PR-4D', 'Yabucoa, PR'],
  ['PR-4E', 'Yauco, PR'],
  ['RI-01', 'Bristol, RI'],
  ['RI-02', 'Kent, RI'],
  ['RI-03', 'Newport, RI'],
  ['RI-04', 'Providence, RI'],
  ['RI-05', 'Washington, RI'],
  ['SC-01', 'Abbeville, SC'],
  ['SC-02', 'Aiken, SC'],
  ['SC-03', 'Allendale, SC'],
  ['SC-04', 'Anderson, SC'],
  ['SC-05', 'Bamberg, SC'],
  ['SC-06', 'Barnwell, SC'],
  ['SC-07', 'Beaufort, SC'],
  ['SC-08', 'Berkeley, SC'],
  ['SC-09', 'Calhoun, SC'],
  ['SC-0A', 'Charleston, SC'],
  ['SC-0B', 'Cherokee, SC'],
  ['SC-0C', 'Chester, SC'],
  ['SC-0D', 'Chesterfield, SC'],
  ['SC-0E', 'Clarendon, SC'],
  ['SC-0F', 'Colleton, SC'],
  ['SC-10', 'Darlington, SC'],
  ['SC-11', 'Dillon, SC'],
  ['SC-12', 'Dorchester, SC'],
  ['SC-13', 'Edgefield, SC'],
  ['SC-14', 'Fairfield, SC'],
  ['SC-15', 'Florence, SC'],
  ['SC-16', 'Georgetown, SC'],
  ['SC-17', 'Greenville, SC'],
  ['SC-18', 'Greenwood, SC'],
  ['SC-19', 'Hampton, SC'],
  ['SC-1A', 'Horry, SC'],
  ['SC-1B', 'Jasper, SC'],
  ['SC-1C', 'Kershaw, SC'],
  ['SC-1D', 'Lancaster, SC'],
  ['SC-1E', 'Laurens, SC'],
  ['SC-1F', 'Lee, SC'],
  ['SC-20', 'Lexington, SC'],
  ['SC-21', 'McCormick, SC'],
  ['SC-22', 'Marion, SC'],
  ['SC-23', 'Marlboro, SC'],
  ['SC-24', 'Newberry, SC'],
  ['SC-25', 'Oconee, SC'],
  ['SC-26', 'Orangeburg, SC'],
  ['SC-27', 'Pickens, SC'],
  ['SC-28', 'Richland, SC'],
  ['SC-29', 'Saluda, SC'],
  ['SC-2A', 'Spartanburg, SC'],
  ['SC-2B', 'Sumter, SC'],
  ['SC-2C', 'Union, SC'],
  ['SC-2D', 'Williamsburg, SC'],
  ['SC-2E', 'York, SC'],
  ['SD-01', 'Aurora, SD'],
  ['SD-02', 'Beadle, SD'],
  ['SD-03', 'Bennett, SD'],
  ['SD-04', 'Bon Homme, SD'],
  ['SD-05', 'Brookings, SD'],
  ['SD-06', 'Brown, SD'],
  ['SD-07', 'Brule, SD'],
  ['SD-08', 'Buffalo, SD'],
  ['SD-09', 'Butte, SD'],
  ['SD-0A', 'Campbell, SD'],
  ['SD-0B', 'Charles Mix, SD'],
  ['SD-0C', 'Clark, SD'],
  ['SD-0D', 'Clay, SD'],
  ['SD-0E', 'Codington, SD'],
  ['SD-0F', 'Corson, SD'],
  ['SD-10', 'Custer, SD'],
  ['SD-11', 'Davison, SD'],
  ['SD-12', 'Day, SD'],
  ['SD-13', 'Deuel, SD'],
  ['SD-14', 'Dewey, SD'],
  ['SD-15', 'Douglas, SD'],
  ['SD-16', 'Edmunds, SD'],
  ['SD-17', 'Fall River, SD'],
  ['SD-18', 'Faulk, SD'],
  ['SD-19', 'Grant, SD'],
  ['SD-1A', 'Gregory, SD'],
  ['SD-1B', 'Haakon, SD'],
  ['SD-1C', 'Hamlin, SD'],
  ['SD-1D', 'Hand, SD'],
  ['SD-1E', 'Hanson, SD'],
  ['SD-1F', 'Harding, SD'],
  ['SD-20', 'Hughes, SD'],
  ['SD-21', 'Hutchinson, SD'],
  ['SD-22', 'Hyde, SD'],
  ['SD-23', 'Jackson, SD'],
  ['SD-24', 'Jerauld, SD'],
  ['SD-25', 'Jones, SD'],
  ['SD-26', 'Kingsbury, SD'],
  ['SD-27', 'Lake, SD'],
  ['SD-28', 'Lawrence, SD'],
  ['SD-29', 'Lincoln, SD'],
  ['SD-2A', 'Lyman, SD'],
  ['SD-2B', 'McCook, SD'],
  ['SD-2C', 'McPherson, SD'],
  ['SD-2D', 'Marshall, SD'],
  ['SD-2E', 'Meade, SD'],
  ['SD-2F', 'Mellette, SD'],
  ['SD-30', 'Miner, SD'],
  ['SD-31', 'Minnehaha, SD'],
  ['SD-32', 'Moody, SD'],
  ['SD-33', 'Oglala Lakota, SD'],
  ['SD-34', 'Pennington, SD'],
  ['SD-35', 'Perkins, SD'],
  ['SD-36', 'Potter, SD'],
  ['SD-37', 'Roberts, SD'],
  ['SD-38', 'Sanborn, SD'],
  ['SD-39', 'Spink, SD'],
  ['SD-3A', 'Stanley, SD'],
  ['SD-3B', 'Sully, SD'],
  ['SD-3C', 'Todd, SD'],
  ['SD-3D', 'Tripp, SD'],
  ['SD-3E', 'Turner, SD'],
  ['SD-3F', 'Union, SD'],
  ['SD-40', 'Walworth, SD'],
  ['SD-41', 'Yankton, SD'],
  ['SD-42', 'Ziebach, SD'],
  ['TN-01', 'Anderson, TN'],
  ['TN-02', 'Bedford, TN'],
  ['TN-03', 'Benton, TN'],
  ['TN-04', 'Bledsoe, TN'],
  ['TN-05', 'Blount, TN'],
  ['TN-06', 'Bradley, TN'],
  ['TN-07', 'Campbell, TN'],
  ['TN-08', 'Cannon, TN'],
  ['TN-09', 'Carroll, TN'],
  ['TN-0A', 'Carter, TN'],
  ['TN-0B', 'Cheatham, TN'],
  ['TN-0C', 'Chester, TN'],
  ['TN-0D', 'Claiborne, TN'],
  ['TN-0E', 'Clay, TN'],
  ['TN-0F', 'Cocke, TN'],
  ['TN-10', 'Coffee, TN'],
  ['TN-11', 'Crockett, TN'],
  ['TN-12', 'Cumberland, TN'],
  ['TN-13', 'Davidson, TN'],
  ['TN-14', 'Decatur, TN'],
  ['TN-15', 'DeKalb, TN'],
  ['TN-16', 'Dickson, TN'],
  ['TN-17', 'Dyer, TN'],
  ['TN-18', 'Fayette, TN'],
  ['TN-19', 'Fentress, TN'],
  ['TN-1A', 'Franklin, TN'],
  ['TN-1B', 'Gibson, TN'],
  ['TN-1C', 'Giles, TN'],
  ['TN-1D', 'Grainger, TN'],
  ['TN-1E', 'Greene, TN'],
  ['TN-1F', 'Grundy, TN'],
  ['TN-20', 'Hamblen, TN'],
  ['TN-21', 'Hamilton, TN'],
  ['TN-22', 'Hancock, TN'],
  ['TN-23', 'Hardeman, TN'],
  ['TN-24', 'Hardin, TN'],
  ['TN-25', 'Hawkins, TN'],
  ['TN-26', 'Haywood, TN'],
  ['TN-27', 'Henderson, TN'],
  ['TN-28', 'Henry, TN'],
  ['TN-29', 'Hickman, TN'],
  ['TN-2A', 'Houston, TN'],
  ['TN-2B', 'Humphreys, TN'],
  ['TN-2C', 'Jackson, TN'],
  ['TN-2D', 'Jefferson, TN'],
  ['TN-2E', 'Johnson, TN'],
  ['TN-2F', 'Knox, TN'],
  ['TN-30', 'Lake, TN'],
  ['TN-31', 'Lauderdale, TN'],
  ['TN-32', 'Lawrence, TN'],
  ['TN-33', 'Lewis, TN'],
  ['TN-34', 'Lincoln, TN'],
  ['TN-35', 'Loudon, TN'],
  ['TN-36', 'McMinn, TN'],
  ['TN-37', 'McNairy, TN'],
  ['TN-38', 'Macon, TN'],
  ['TN-39', 'Madison, TN'],
  ['TN-3A', 'Marion, TN'],
  ['TN-3B', 'Marshall, TN'],
  ['TN-3C', 'Maury, TN'],
  ['TN-3D', 'Meigs, TN'],
  ['TN-3E', 'Monroe, TN'],
  ['TN-3F', 'Montgomery, TN'],
  ['TN-40', 'Moore, TN'],
  ['TN-41', 'Morgan, TN'],
  ['TN-42', 'Obion, TN'],
  ['TN-43', 'Overton, TN'],
  ['TN-44', 'Perry, TN'],
  ['TN-45', 'Pickett, TN'],
  ['TN-46', 'Polk, TN'],
  ['TN-47', 'Putnam, TN'],
  ['TN-48', 'Rhea, TN'],
  ['TN-49', 'Roane, TN'],
  ['TN-4A', 'Robertson, TN'],
  ['TN-4B', 'Rutherford, TN'],
  ['TN-4C', 'Scott, TN'],
  ['TN-4D', 'Sequatchie, TN'],
  ['TN-4E', 'Sevier, TN'],
  ['TN-4F', 'Shelby, TN'],
  ['TN-50', 'Smith, TN'],
  ['TN-51', 'Stewart, TN'],
  ['TN-52', 'Sullivan, TN'],
  ['TN-53', 'Sumner, TN'],
  ['TN-54', 'Tipton, TN'],
  ['TN-55', 'Trousdale, TN'],
  ['TN-56', 'Unicoi, TN'],
  ['TN-57', 'Union, TN'],
  ['TN-58', 'Van Buren, TN'],
  ['TN-59', 'Warren, TN'],
  ['TN-5A', 'Washington, TN'],
  ['TN-5B', 'Wayne, TN'],
  ['TN-5C', 'Weakley, TN'],
  ['TN-5D', 'White, TN'],
  ['TN-5E', 'Williamson, TN'],
  ['TN-5F', 'Wilson, TN'],
  ['TX-01', 'Anderson, TX'],
  ['TX-02', 'Andrews, TX'],
  ['TX-03', 'Angelina, TX'],
  ['TX-04', 'Aransas, TX'],
  ['TX-05', 'Archer, TX'],
  ['TX-06', 'Armstrong, TX'],
  ['TX-07', 'Atascosa, TX'],
  ['TX-08', 'Austin, TX'],
  ['TX-09', 'Bailey, TX'],
  ['TX-0A', 'Bandera, TX'],
  ['TX-0B', 'Bastrop, TX'],
  ['TX-0C', 'Baylor, TX'],
  ['TX-0D', 'Bee, TX'],
  ['TX-0E', 'Bell, TX'],
  ['TX-0F', 'Bexar, TX'],
  ['TX-10', 'Blanco, TX'],
  ['TX-11', 'Borden, TX'],
  ['TX-12', 'Bosque, TX'],
  ['TX-13', 'Bowie, TX'],
  ['TX-14', 'Brazoria, TX'],
  ['TX-15', 'Brazos, TX'],
  ['TX-16', 'Brewster, TX'],
  ['TX-17', 'Briscoe, TX'],
  ['TX-18', 'Brooks, TX'],
  ['TX-19', 'Brown, TX'],
  ['TX-1A', 'Burleson, TX'],
  ['TX-1B', 'Burnet, TX'],
  ['TX-1C', 'Caldwell, TX'],
  ['TX-1D', 'Calhoun, TX'],
  ['TX-1E', 'Callahan, TX'],
  ['TX-1F', 'Cameron, TX'],
  ['TX-20', 'Camp, TX'],
  ['TX-21', 'Carson, TX'],
  ['TX-22', 'Cass, TX'],
  ['TX-23', 'Castro, TX'],
  ['TX-24', 'Chambers, TX'],
  ['TX-25', 'Cherokee, TX'],
  ['TX-26', 'Childress, TX'],
  ['TX-27', 'Clay, TX'],
  ['TX-28', 'Cochran, TX'],
  ['TX-29', 'Coke, TX'],
  ['TX-2A', 'Coleman, TX'],
  ['TX-2B', 'Collin, TX'],
  ['TX-2C', 'Collingsworth, TX'],
  ['TX-2D', 'Colorado, TX'],
  ['TX-2E', 'Comal, TX'],
  ['TX-2F', 'Comanche, TX'],
  ['TX-30', 'Concho, TX'],
  ['TX-31', 'Cooke, TX'],
  ['TX-32', 'Coryell, TX'],
  ['TX-33', 'Cottle, TX'],
  ['TX-34', 'Crane, TX'],
  ['TX-35', 'Crockett, TX'],
  ['TX-36', 'Crosby, TX'],
  ['TX-37', 'Culberson, TX'],
  ['TX-38', 'Dallam, TX'],
  ['TX-39', 'Dallas, TX'],
  ['TX-3A', 'Dawson, TX'],
  ['TX-3B', 'Deaf Smith, TX'],
  ['TX-3C', 'Delta, TX'],
  ['TX-3D', 'Denton, TX'],
  ['TX-3E', 'DeWitt, TX'],
  ['TX-3F', 'Dickens, TX'],
  ['TX-40', 'Dimmit, TX'],
  ['TX-41', 'Donley, TX'],
  ['TX-42', 'Duval, TX'],
  ['TX-43', 'Eastland, TX'],
  ['TX-44', 'Ector, TX'],
  ['TX-45', 'Edwards, TX'],
  ['TX-46', 'Ellis, TX'],
  ['TX-47', 'El Paso, TX'],
  ['TX-48', 'Erath, TX'],
  ['TX-49', 'Falls, TX'],
  ['TX-4A', 'Fannin, TX'],
  ['TX-4B', 'Fayette, TX'],
  ['TX-4C', 'Fisher, TX'],
  ['TX-4D', 'Floyd, TX'],
  ['TX-4E', 'Foard, TX'],
  ['TX-4F', 'Fort Bend, TX'],
  ['TX-50', 'Franklin, TX'],
  ['TX-51', 'Freestone, TX'],
  ['TX-52', 'Frio, TX'],
  ['TX-53', 'Gaines, TX'],
  ['TX-54', 'Galveston, TX'],
  ['TX-55', 'Garza, TX'],
  ['TX-56', 'Gillespie, TX'],
  ['TX-57', 'Glasscock, TX'],
  ['TX-58', 'Goliad, TX'],
  ['TX-59', 'Gonzales, TX'],
  ['TX-5A', 'Gray, TX'],
  ['TX-5B', 'Grayson, TX'],
  ['TX-5C', 'Gregg, TX'],
  ['TX-5D', 'Grimes, TX'],
  ['TX-5E', 'Guadalupe, TX'],
  ['TX-5F', 'Hale, TX'],
  ['TX-60', 'Hall, TX'],
  ['TX-61', 'Hamilton, TX'],
  ['TX-62', 'Hansford, TX'],
  ['TX-63', 'Hardeman, TX'],
  ['TX-64', 'Hardin, TX'],
  ['TX-65', 'Harris, TX'],
  ['TX-66', 'Harrison, TX'],
  ['TX-67', 'Hartley, TX'],
  ['TX-68', 'Haskell, TX'],
  ['TX-69', 'Hays, TX'],
  ['TX-6A', 'Hemphill, TX'],
  ['TX-6B', 'Henderson, TX'],
  ['TX-6C', 'Hidalgo, TX'],
  ['TX-6D', 'Hill, TX'],
  ['TX-6E', 'Hockley, TX'],
  ['TX-6F', 'Hood, TX'],
  ['TX-70', 'Hopkins, TX'],
  ['TX-71', 'Houston, TX'],
  ['TX-72', 'Howard, TX'],
  ['TX-73', 'Hudspeth, TX'],
  ['TX-74', 'Hunt, TX'],
  ['TX-75', 'Hutchinson, TX'],
  ['TX-76', 'Irion, TX'],
  ['TX-77', 'Jack, TX'],
  ['TX-78', 'Jackson, TX'],
  ['TX-79', 'Jasper, TX'],
  ['TX-7A', 'Jeff Davis, TX'],
  ['TX-7B', 'Jefferson, TX'],
  ['TX-7C', 'Jim Hogg, TX'],
  ['TX-7D', 'Jim Wells, TX'],
  ['TX-7E', 'Johnson, TX'],
  ['TX-7F', 'Jones, TX'],
  ['TX-80', 'Karnes, TX'],
  ['TX-81', 'Kaufman, TX'],
  ['TX-82', 'Kendall, TX'],
  ['TX-83', 'Kenedy, TX'],
  ['TX-84', 'Kent, TX'],
  ['TX-85', 'Kerr, TX'],
  ['TX-86', 'Kimble, TX'],
  ['TX-87', 'King, TX'],
  ['TX-88', 'Kinney, TX'],
  ['TX-89', 'Kleberg, TX'],
  ['TX-8A', 'Knox, TX'],
  ['TX-8B', 'Lamar, TX'],
  ['TX-8C', 'Lamb, TX'],
  ['TX-8D', 'Lampasas, TX'],
  ['TX-8E', 'La Salle, TX'],
  ['TX-8F', 'Lavaca, TX'],
  ['TX-90', 'Lee, TX'],
  ['TX-91', 'Leon, TX'],
  ['TX-92', 'Liberty, TX'],
  ['TX-93', 'Limestone, TX'],
  ['TX-94', 'Lipscomb, TX'],
  ['TX-95', 'Live Oak, TX'],
  ['TX-96', 'Llano, TX'],
  ['TX-97', 'Loving, TX'],
  ['TX-98', 'Lubbock, TX'],
  ['TX-99', 'Lynn, TX'],
  ['TX-9A', 'McCulloch, TX'],
  ['TX-9B', 'McLennan, TX'],
  ['TX-9C', 'McMullen, TX'],
  ['TX-9D', 'Madison, TX'],
  ['TX-9E', 'Marion, TX'],
  ['TX-9F', 'Martin, TX'],
  ['TX-A0', 'Mason, TX'],
  ['TX-A1', 'Matagorda, TX'],
  ['TX-A2', 'Maverick, TX'],
  ['TX-A3', 'Medina, TX'],
  ['TX-A4', 'Menard, TX'],
  ['TX-A5', 'Midland, TX'],
  ['TX-A6', 'Milam, TX'],
  ['TX-A7', 'Mills, TX'],
  ['TX-A8', 'Mitchell, TX'],
  ['TX-A9', 'Montague, TX'],
  ['TX-AA', 'Montgomery, TX'],
  ['TX-AB', 'Moore, TX'],
  ['TX-AC', 'Morris, TX'],
  ['TX-AD', 'Motley, TX'],
  ['TX-AE', 'Nacogdoches, TX'],
  ['TX-AF', 'Navarro, TX'],
  ['TX-B0', 'Newton, TX'],
  ['TX-B1', 'Nolan, TX'],
  ['TX-B2', 'Nueces, TX'],
  ['TX-B3', 'Ochiltree, TX'],
  ['TX-B4', 'Oldham, TX'],
  ['TX-B5', 'Orange, TX'],
  ['TX-B6', 'Palo Pinto, TX'],
  ['TX-B7', 'Panola, TX'],
  ['TX-B8', 'Parker, TX'],
  ['TX-B9', 'Parmer, TX'],
  ['TX-BA', 'Pecos, TX'],
  ['TX-BB', 'Polk, TX'],
  ['TX-BC', 'Potter, TX'],
  ['TX-BD', 'Presidio, TX'],
  ['TX-BE', 'Rains, TX'],
  ['TX-BF', 'Randall, TX'],
  ['TX-C0', 'Reagan, TX'],
  ['TX-C1', 'Real, TX'],
  ['TX-C2', 'Red River, TX'],
  ['TX-C3', 'Reeves, TX'],
  ['TX-C4', 'Refugio, TX'],
  ['TX-C5', 'Roberts, TX'],
  ['TX-C6', 'Robertson, TX'],
  ['TX-C7', 'Rockwall, TX'],
  ['TX-C8', 'Runnels, TX'],
  ['TX-C9', 'Rusk, TX'],
  ['TX-CA', 'Sabine, TX'],
  ['TX-CB', 'San Augustine, TX'],
  ['TX-CC', 'San Jacinto, TX'],
  ['TX-CD', 'San Patricio, TX'],
  ['TX-CE', 'San Saba, TX'],
  ['TX-CF', 'Schleicher, TX'],
  ['TX-D0', 'Scurry, TX'],
  ['TX-D1', 'Shackelford, TX'],
  ['TX-D2', 'Shelby, TX'],
  ['TX-D3', 'Sherman, TX'],
  ['TX-D4', 'Smith, TX'],
  ['TX-D5', 'Somervell, TX'],
  ['TX-D6', 'Starr, TX'],
  ['TX-D7', 'Stephens, TX'],
  ['TX-D8', 'Sterling, TX'],
  ['TX-D9', 'Stonewall, TX'],
  ['TX-DA', 'Sutton, TX'],
  ['TX-DB', 'Swisher, TX'],
  ['TX-DC', 'Tarrant, TX'],
  ['TX-DD', 'Taylor, TX'],
  ['TX-DE', 'Terrell, TX'],
  ['TX-DF', 'Terry, TX'],
  ['TX-E0', 'Throckmorton, TX'],
  ['TX-E1', 'Titus, TX'],
  ['TX-E2', 'Tom Green, TX'],
  ['TX-E3', 'Travis, TX'],
  ['TX-E4', 'Trinity, TX'],
  ['TX-E5', 'Tyler, TX'],
  ['TX-E6', 'Upshur, TX'],
  ['TX-E7', 'Upton, TX'],
  ['TX-E8', 'Uvalde, TX'],
  ['TX-E9', 'Val Verde, TX'],
  ['TX-EA', 'Van Zandt, TX'],
  ['TX-EB', 'Victoria, TX'],
  ['TX-EC', 'Walker, TX'],
  ['TX-ED', 'Waller, TX'],
  ['TX-EE', 'Ward, TX'],
  ['TX-EF', 'Washington, TX'],
  ['TX-F0', 'Webb, TX'],
  ['TX-F1', 'Wharton, TX'],
  ['TX-F2', 'Wheeler, TX'],
  ['TX-F3', 'Wichita, TX'],
  ['TX-F4', 'Wilbarger, TX'],
  ['TX-F5', 'Willacy, TX'],
  ['TX-F6', 'Williamson, TX'],
  ['TX-F7', 'Wilson, TX'],
  ['TX-F8', 'Winkler, TX'],
  ['TX-F9', 'Wise, TX'],
  ['TX-FA', 'Wood, TX'],
  ['TX-FB', 'Yoakum, TX'],
  ['TX-FC', 'Young, TX'],
  ['TX-FD', 'Zapata, TX'],
  ['TX-FE', 'Zavala, TX'],
  ['UT-01', 'Beaver, UT'],
  ['UT-02', 'Box Elder, UT'],
  ['UT-03', 'Cache, UT'],
  ['UT-04', 'Carbon, UT'],
  ['UT-05', 'Daggett, UT'],
  ['UT-06', 'Davis, UT'],
  ['UT-07', 'Duchesne, UT'],
  ['UT-08', 'Emery, UT'],
  ['UT-09', 'Garfield, UT'],
  ['UT-0A', 'Grand, UT'],
  ['UT-0B', 'Iron, UT'],
  ['UT-0C', 'Juab, UT'],
  ['UT-0D', 'Kane, UT'],
  ['UT-0E', 'Millard, UT'],
  ['UT-0F', 'Morgan, UT'],
  ['UT-10', 'Piute, UT'],
  ['UT-11', 'Rich, UT'],
  ['UT-12', 'Salt Lake, UT'],
  ['UT-13', 'San Juan, UT'],
  ['UT-14', 'Sanpete, UT'],
  ['UT-15', 'Sevier, UT'],
  ['UT-16', 'Summit, UT'],
  ['UT-17', 'Tooele, UT'],
  ['UT-18', 'Uintah, UT'],
  ['UT-19', 'Utah, UT'],
  ['UT-1A', 'Wasatch, UT'],
  ['UT-1B', 'Washington, UT'],
  ['UT-1C', 'Wayne, UT'],
  ['UT-1D', 'Weber, UT'],
  ['VT-01', 'Addison, VT'],
  ['VT-02', 'Bennington, VT'],
  ['VT-03', 'Caledonia, VT'],
  ['VT-04', 'Chittenden, VT'],
  ['VT-05', 'Essex, VT'],
  ['VT-06', 'Franklin, VT'],
  ['VT-07', 'Grand Isle, VT'],
  ['VT-08', 'Lamoille, VT'],
  ['VT-09', 'Orange, VT'],
  ['VT-0A', 'Orleans, VT'],
  ['VT-0B', 'Rutland, VT'],
  ['VT-0C', 'Washington, VT'],
  ['VT-0D', 'Windham, VT'],
  ['VT-0E', 'Windsor, VT'],
  ['VA-01', 'Accomack, VA'],
  ['VA-02', 'Albemarle, VA'],
  ['VA-03', 'Alleghany, VA'],
  ['VA-04', 'Amelia, VA'],
  ['VA-05', 'Amherst, VA'],
  ['VA-06', 'Appomattox, VA'],
  ['VA-07', 'Arlington, VA'],
  ['VA-08', 'Augusta, VA'],
  ['VA-09', 'Bath, VA'],
  ['VA-0A', 'Bedford, VA'],
  ['VA-0B', 'Bland, VA'],
  ['VA-0C', 'Botetourt, VA'],
  ['VA-0D', 'Brunswick, VA'],
  ['VA-0E', 'Buchanan, VA'],
  ['VA-0F', 'Buckingham, VA'],
  ['VA-10', 'Campbell, VA'],
  ['VA-11', 'Caroline, VA'],
  ['VA-12', 'Carroll, VA'],
  ['VA-13', 'Charles City, VA'],
  ['VA-14', 'Charlotte, VA'],
  ['VA-15', 'Chesterfield, VA'],
  ['VA-16', 'Clarke, VA'],
  ['VA-17', 'Craig, VA'],
  ['VA-18', 'Culpeper, VA'],
  ['VA-19', 'Cumberland, VA'],
  ['VA-1A', 'Dickenson, VA'],
  ['VA-1B', 'Dinwiddie, VA'],
  ['VA-1C', 'Essex, VA'],
  ['VA-1D', 'Fairfax, VA'],
  ['VA-1E', 'Fauquier, VA'],
  ['VA-1F', 'Floyd, VA'],
  ['VA-20', 'Fluvanna, VA'],
  ['VA-21', 'Franklin, VA'],
  ['VA-22', 'Frederick, VA'],
  ['VA-23', 'Giles, VA'],
  ['VA-24', 'Gloucester, VA'],
  ['VA-25', 'Goochland, VA'],
  ['VA-26', 'Grayson, VA'],
  ['VA-27', 'Greene, VA'],
  ['VA-28', 'Greensville, VA'],
  ['VA-29', 'Halifax, VA'],
  ['VA-2A', 'Hanover, VA'],
  ['VA-2B', 'Henrico, VA'],
  ['VA-2C', 'Henry, VA'],
  ['VA-2D', 'Highland, VA'],
  ['VA-2E', 'Isle of Wight, VA'],
  ['VA-2F', 'James City, VA'],
  ['VA-30', 'King and Queen, VA'],
  ['VA-31', 'King George, VA'],
  ['VA-32', 'King William, VA'],
  ['VA-33', 'Lancaster, VA'],
  ['VA-34', 'Lee, VA'],
  ['VA-35', 'Loudoun, VA'],
  ['VA-36', 'Louisa, VA'],
  ['VA-37', 'Lunenburg, VA'],
  ['VA-38', 'Madison, VA'],
  ['VA-39', 'Mathews, VA'],
  ['VA-3A', 'Mecklenburg, VA'],
  ['VA-3B', 'Middlesex, VA'],
  ['VA-3C', 'Montgomery, VA'],
  ['VA-3D', 'Nelson, VA'],
  ['VA-3E', 'New Kent, VA'],
  ['VA-3F', 'Northampton, VA'],
  ['VA-40', 'Northumberland, VA'],
  ['VA-41', 'Nottoway, VA'],
  ['VA-42', 'Orange, VA'],
  ['VA-43', 'Page, VA'],
  ['VA-44', 'Patrick, VA'],
  ['VA-45', 'Pittsylvania, VA'],
  ['VA-46', 'Powhatan, VA'],
  ['VA-47', 'Prince Edward, VA'],
  ['VA-48', 'Prince George, VA'],
  ['VA-49', 'Prince William, VA'],
  ['VA-4A', 'Pulaski, VA'],
  ['VA-4B', 'Rappahannock, VA'],
  ['VA-4C', 'Richmond, VA'],
  ['VA-4D', 'Roanoke, VA'],
  ['VA-4E', 'Rockbridge, VA'],
  ['VA-4F', 'Rockingham, VA'],
  ['VA-50', 'Russell, VA'],
  ['VA-51', 'Scott, VA'],
  ['VA-52', 'Shenandoah, VA'],
  ['VA-53', 'Smyth, VA'],
  ['VA-54', 'Southampton, VA'],
  ['VA-55', 'Spotsylvania, VA'],
  ['VA-56', 'Stafford, VA'],
  ['VA-57', 'Surry, VA'],
  ['VA-58', 'Sussex, VA'],
  ['VA-59', 'Tazewell, VA'],
  ['VA-5A', 'Warren, VA'],
  ['VA-5B', 'Washington, VA'],
  ['VA-5C', 'Westmoreland, VA'],
  ['VA-5D', 'Wise, VA'],
  ['VA-5E', 'Wythe, VA'],
  ['VA-5F', 'York, VA'],
  ['VA-60', 'Alexandria City, VA'],
  ['VA-61', 'Bristol City, VA'],
  ['VA-62', 'Buena Vista City, VA'],
  ['VA-63', 'Charlottesville City, VA'],
  ['VA-64', 'Chesapeake City, VA'],
  ['VA-65', 'Colonial Heights City, VA'],
  ['VA-66', 'Covington City, VA'],
  ['VA-67', 'Danville City, VA'],
  ['VA-68', 'Emporia City, VA'],
  ['VA-69', 'Fairfax City, VA'],
  ['VA-6A', 'Falls Church City, VA'],
  ['VA-6B', 'Franklin City, VA'],
  ['VA-6C', 'Fredericksburg City, VA'],
  ['VA-6D', 'Galax City, VA'],
  ['VA-6E', 'Hampton City, VA'],
  ['VA-6F', 'Harrisonburg City, VA'],
  ['VA-70', 'Hopewell City, VA'],
  ['VA-71', 'Lexington City, VA'],
  ['VA-72', 'Lynchburg City, VA'],
  ['VA-73', 'Manassas City, VA'],
  ['VA-74', 'Manassas Park City, VA'],
  ['VA-75', 'Martinsville City, VA'],
  ['VA-76', 'Newport News City, VA'],
  ['VA-77', 'Norfolk City, VA'],
  ['VA-78', 'Norton City, VA'],
  ['VA-79', 'Petersburg City, VA'],
  ['VA-7A', 'Poquoson City, VA'],
  ['VA-7B', 'Portsmouth City, VA'],
  ['VA-7C', 'Radford City, VA'],
  ['VA-7D', 'Richmond City, VA'],
  ['VA-7E', 'Roanoke City, VA'],
  ['VA-7F', 'Salem City, VA'],
  ['VA-80', 'Staunton City, VA'],
  ['VA-81', 'Suffolk City, VA'],
  ['VA-82', 'Virginia Beach City, VA'],
  ['VA-83', 'Waynesboro City, VA'],
  ['VA-84', 'Williamsburg City, VA'],
  ['VA-85', 'Winchester City, VA'],
  ['WA-01', 'Adams, WA'],
  ['WA-02', 'Asotin, WA'],
  ['WA-03', 'Benton, WA'],
  ['WA-04', 'Chelan, WA'],
  ['WA-05', 'Clallam, WA'],
  ['WA-06', 'Clark, WA'],
  ['WA-07', 'Columbia, WA'],
  ['WA-08', 'Cowlitz, WA'],
  ['WA-09', 'Douglas, WA'],
  ['WA-0A', 'Ferry, WA'],
  ['WA-0B', 'Franklin, WA'],
  ['WA-0C', 'Garfield, WA'],
  ['WA-0D', 'Grant, WA'],
  ['WA-0E', 'Grays Harbor, WA'],
  ['WA-0F', 'Island, WA'],
  ['WA-10', 'Jefferson, WA'],
  ['WA-11', 'King, WA'],
  ['WA-12', 'Kitsap, WA'],
  ['WA-13', 'Kittitas, WA'],
  ['WA-14', 'Klickitat, WA'],
  ['WA-15', 'Lewis, WA'],
  ['WA-16', 'Lincoln, WA'],
  ['WA-17', 'Mason, WA'],
  ['WA-18', 'Okanogan, WA'],
  ['WA-19', 'Pacific, WA'],
  ['WA-1A', 'Pend Oreille, WA'],
  ['WA-1B', 'Pierce, WA'],
  ['WA-1C', 'San Juan, WA'],
  ['WA-1D', 'Skagit, WA'],
  ['WA-1E', 'Skamania, WA'],
  ['WA-1F', 'Snohomish, WA'],
  ['WA-20', 'Spokane, WA'],
  ['WA-21', 'Stevens, WA'],
  ['WA-22', 'Thurston, WA'],
  ['WA-23', 'Wahkiakum, WA'],
  ['WA-24', 'Walla Walla, WA'],
  ['WA-25', 'Whatcom, WA'],
  ['WA-26', 'Whitman, WA'],
  ['WA-27', 'Yakima, WA'],
  ['WV-01', 'Barbour, WV'],
  ['WV-02', 'Berkeley, WV'],
  ['WV-03', 'Boone, WV'],
  ['WV-04', 'Braxton, WV'],
  ['WV-05', 'Brooke, WV'],
  ['WV-06', 'Cabell, WV'],
  ['WV-07', 'Calhoun, WV'],
  ['WV-08', 'Clay, WV'],
  ['WV-09', 'Doddridge, WV'],
  ['WV-0A', 'Fayette, WV'],
  ['WV-0B', 'Gilmer, WV'],
  ['WV-0C', 'Grant, WV'],
  ['WV-0D', 'Greenbrier, WV'],
  ['WV-0E', 'Hampshire, WV'],
  ['WV-0F', 'Hancock, WV'],
  ['WV-10', 'Hardy, WV'],
  ['WV-11', 'Harrison, WV'],
  ['WV-12', 'Jackson, WV'],
  ['WV-13', 'Jefferson, WV'],
  ['WV-14', 'Kanawha, WV'],
  ['WV-15', 'Lewis, WV'],
  ['WV-16', 'Lincoln, WV'],
  ['WV-17', 'Logan, WV'],
  ['WV-18', 'McDowell, WV'],
  ['WV-19', 'Marion, WV'],
  ['WV-1A', 'Marshall, WV'],
  ['WV-1B', 'Mason, WV'],
  ['WV-1C', 'Mercer, WV'],
  ['WV-1D', 'Mineral, WV'],
  ['WV-1E', 'Mingo, WV'],
  ['WV-1F', 'Monongalia, WV'],
  ['WV-20', 'Monroe, WV'],
  ['WV-21', 'Morgan, WV'],
  ['WV-22', 'Nicholas, WV'],
  ['WV-23', 'Ohio, WV'],
  ['WV-24', 'Pendleton, WV'],
  ['WV-25', 'Pleasants, WV'],
  ['WV-26', 'Pocahontas, WV'],
  ['WV-27', 'Preston, WV'],
  ['WV-28', 'Putnam, WV'],
  ['WV-29', 'Raleigh, WV'],
  ['WV-2A', 'Randolph, WV'],
  ['WV-2B', 'Ritchie, WV'],
  ['WV-2C', 'Roane, WV'],
  ['WV-2D', 'Summers, WV'],
  ['WV-2E', 'Taylor, WV'],
  ['WV-2F', 'Tucker, WV'],
  ['WV-30', 'Tyler, WV'],
  ['WV-31', 'Upshur, WV'],
  ['WV-32', 'Wayne, WV'],
  ['WV-33', 'Webster, WV'],
  ['WV-34', 'Wetzel, WV'],
  ['WV-35', 'Wirt, WV'],
  ['WV-36', 'Wood, WV'],
  ['WV-37', 'Wyoming, WV'],
  ['WI-01', 'Adams, WI'],
  ['WI-02', 'Ashland, WI'],
  ['WI-03', 'Barron, WI'],
  ['WI-04', 'Bayfield, WI'],
  ['WI-05', 'Brown, WI'],
  ['WI-06', 'Buffalo, WI'],
  ['WI-07', 'Burnett, WI'],
  ['WI-08', 'Calumet, WI'],
  ['WI-09', 'Chippewa, WI'],
  ['WI-0A', 'Clark, WI'],
  ['WI-0B', 'Columbia, WI'],
  ['WI-0C', 'Crawford, WI'],
  ['WI-0D', 'Dane, WI'],
  ['WI-0E', 'Dodge, WI'],
  ['WI-0F', 'Door, WI'],
  ['WI-10', 'Douglas, WI'],
  ['WI-11', 'Dunn, WI'],
  ['WI-12', 'Eau Claire, WI'],
  ['WI-13', 'Florence, WI'],
  ['WI-14', 'Fond du Lac, WI'],
  ['WI-15', 'Forest, WI'],
  ['WI-16', 'Grant, WI'],
  ['WI-17', 'Green, WI'],
  ['WI-18', 'Green Lake, WI'],
  ['WI-19', 'Iowa, WI'],
  ['WI-1A', 'Iron, WI'],
  ['WI-1B', 'Jackson, WI'],
  ['WI-1C', 'Jefferson, WI'],
  ['WI-1D', 'Juneau, WI'],
  ['WI-1E', 'Kenosha, WI'],
  ['WI-1F', 'Kewaunee, WI'],
  ['WI-20', 'La Crosse, WI'],
  ['WI-21', 'Lafayette, WI'],
  ['WI-22', 'Langlade, WI'],
  ['WI-23', 'Lincoln, WI'],
  ['WI-24', 'Manitowoc, WI'],
  ['WI-25', 'Marathon, WI'],
  ['WI-26', 'Marinette, WI'],
  ['WI-27', 'Marquette, WI'],
  ['WI-28', 'Menominee, WI'],
  ['WI-29', 'Milwaukee, WI'],
  ['WI-2A', 'Monroe, WI'],
  ['WI-2B', 'Oconto, WI'],
  ['WI-2C', 'Oneida, WI'],
  ['WI-2D', 'Outagamie, WI'],
  ['WI-2E', 'Ozaukee, WI'],
  ['WI-2F', 'Pepin, WI'],
  ['WI-30', 'Pierce, WI'],
  ['WI-31', 'Polk, WI'],
  ['WI-32', 'Portage, WI'],
  ['WI-33', 'Price, WI'],
  ['WI-34', 'Racine, WI'],
  ['WI-35', 'Richland, WI'],
  ['WI-36', 'Rock, WI'],
  ['WI-37', 'Rusk, WI'],
  ['WI-38', 'St. Croix, WI'],
  ['WI-39', 'Sauk, WI'],
  ['WI-3A', 'Sawyer, WI'],
  ['WI-3B', 'Shawano, WI'],
  ['WI-3C', 'Sheboygan, WI'],
  ['WI-3D', 'Taylor, WI'],
  ['WI-3E', 'Trempealeau, WI'],
  ['WI-3F', 'Vernon, WI'],
  ['WI-40', 'Vilas, WI'],
  ['WI-41', 'Walworth, WI'],
  ['WI-42', 'Washburn, WI'],
  ['WI-43', 'Washington, WI'],
  ['WI-44', 'Waukesha, WI'],
  ['WI-45', 'Waupaca, WI'],
  ['WI-46', 'Waushara, WI'],
  ['WI-47', 'Winnebago, WI'],
  ['WI-48', 'Wood, WI'],
  ['WY-01', 'Albany, WY'],
  ['WY-02', 'Big Horn, WY'],
  ['WY-03', 'Campbell, WY'],
  ['WY-04', 'Carbon, WY'],
  ['WY-05', 'Converse, WY'],
  ['WY-06', 'Crook, WY'],
  ['WY-07', 'Fremont, WY'],
  ['WY-08', 'Goshen, WY'],
  ['WY-09', 'Hot Springs, WY'],
  ['WY-0A', 'Johnson, WY'],
  ['WY-0B', 'Laramie, WY'],
  ['WY-0C', 'Lincoln, WY'],
  ['WY-0D', 'Natrona, WY'],
  ['WY-0E', 'Niobrara, WY'],
  ['WY-0F', 'Park, WY'],
  ['WY-10', 'Platte, WY'],
  ['WY-11', 'Sheridan, WY'],
  ['WY-12', 'Sublette, WY'],
  ['WY-13', 'Sweetwater, WY'],
  ['WY-14', 'Teton, WY'],
  ['WY-15', 'Uinta, WY'],
  ['WY-16', 'Washakie, WY'],
  ['WY-17', 'Weston, WY'],
];
